<template> 
	<div class="container-fluid" id="mainDiv" :class="plungeClass">
<!-- FX DEVELOPMENT           -->
	<!-- <h1 style="color: white; background: black;">{{didWeAdventure}}</h1> -->
	<!-- <h1 style="color: white; background: black;">{{masterLevel.toFixed(0)}}</h1> -->
	<!-- <div class="col-xs-2" id="ambienceBtn1Div">
		<input  
			id="ambienceSlider"
			type="range"
			:class="ambiance2RangerClass"
			v-model.number="testVar1"
			:="ambience1Func"
			max="15" min="0" step="0.001"> 
			<br>
			<br>	
			Chorus Freq {{testVar1}}
		</input>
	</div>
	<div class="col-xs-2" id="ambienceBtn1Div">
		<input  
			id="ambienceSlider"
			type="range"
			:class="ambiance2RangerClass"
			v-model.number="testVar2"
			:="ambience1Func"
			max="15" min="0" step="0.001"> 
			<br>
			<br>	
			Chorus Delay {{testVar2}}
		</input>
	</div>
	<div class="col-xs-2" id="ambienceBtn1Div">
		<input  
			id="ambienceSlider"
			type="range"
			:class="ambiance2RangerClass"
			v-model.number="testVar3"
			:="ambience1Func"
			max="2" min="0" step="0.001"> 
			<br>
			<br>	
			Chorus Depth {{testVar3}}
		</input>
	</div>
	<div class="col-xs-2" id="ambienceBtn1Div">
		<input  
			id="ambienceSlider"
			type="range"
			:class="ambiance2RangerClass"
			v-model.number="testVar4"
			:="ambience1Func"
			max="1" min="0" step="0.001"> 
			<br>
			<br>	
			Delay Time {{testVar4}}
		</input>
	</div>
	<div class="col-xs-2" id="ambienceBtn1Div">
		<input  
			id="ambienceSlider"
			type="range"
			:class="ambiance2RangerClass"
			v-model.number="testVar5"
			:="ambience1Func"
			max="1" min="0" step="0.001"> 
			<br>
			<br>	
			Delay Feedback {{testVar5}}
		</input>
	</div> -->
<!-- SPEECH FORM INPUT   	  -->
	<div v-if="this.$store.state.allowSpeechControl">
		<transition
			enter-active-class="animated fadeIn"
			leave-active-class="animated pulse"  
			mode="out-in"
			>	
			<div class="container-fluid" id="VUIformInputDivID" v-show="showAllControls">
				<div class="col-xs-10">
					<input type="text" 
						   :class="plungeClass"
						   style="color:white !important; border-width: 0px;" 
						   class="form-control" 
						   v-model="userVoiceToText" 
						   id="inlineFormInputGroupUsername2" 
						   placeholder="View & Type Voice Commands Here"
						   v-on:keydown.enter="userVoiceToTextFunc" />
				</div>
				<div class="col-xs-2">	
					<span 
						v-if="initSpeech"
						@click="speechFunc"
						> <i id="speechEngage" class="fal fa-microphone-slash" />
					</span>
					<span 
						v-if="!initSpeech"
						@click="speechStartStopFunc"
						><i id="speechEngageActivated" class="fa fa-microphone-alt" 
							v-bind:style="{'color': recognizing ? 'red' : 'black' }" />
					</span>
				</div>
			</div>
		</transition>
	</div>
<!-- ENTER BUTTON             -->
	<div class="container-fluid" id="enterContainer" v-show="showEnterContainer">
		<transition
						appear
						enter-active-class="animated fadeIn"
						leave-active-class="animated tada"  
						mode="out-in">
			 		<button 	
			 				v-show="showEnterBtn"
							class="btn-info"
							id="enterFuncBtn"
							@click.once="enterFunc"
							style="color: gold; background-color: #788487;">
							New York City
					</button>
		</transition>		
		<transition
						enter-active-class="animated fadeIn"
						leave-active-class="animated fadeOut"  
						mode="out-in">

			 		<button v-show="showLoading" 
			 				id="enterFuncBtn" 
			 				style="border-color: transparent; background: transparent;"> 	
							Loading... 
							<br>
							{{whatIsLoading}}
					</button>
		</transition>
	</div>
	<!-- <div class="container-fluid" id="openMicTitle" v-show="showAllControls">		
				<p style="color:white; font-size: 40px;" v-if="!userMobile"> 
					Mic Level: {{micLevel}}
					Low: {{lowAmt}}  Mid: {{midAmt}}  Hi: {{hiAmt}}
				</p>
				<p style="color:black;" v-if="userMobile"> 
					Click A Clip To Learn More
				</p>
					<div class="container-fluid" id="openMicID">
								<div class="col-xs-12">
									<button 
										:class="openMicClass"
										@click="openMic"
										> <i :class="openMicIcon" />
										</button>
										<br>
										<input 
											id="ambienceSlider"
											type="range"
											:class="openMicSliderClass"
											v-model.number="userMicInputLevel"
											:="adjustInputVolume"
											max="15" min="-15" step="0.1"
											> 				
										</input>
								</div>

					</div>
			</div>
		</transition>	 -->			
<!-- CONTROLS          		  -->
		<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated fadeOut"  
					mode="out-in"
					>			
			<div class="container-fluid" id="controlsContainer" v-show="showAllControls">
						<div id="ambienceBtnLocation">
							<p id="fxTitle" style="color:black;" v-if="!userMobile"> 
							Add <i class="fal fa-check-circle" /> or Remove <i class="fal fa-times-circle" /> Sounds From Your <span id="soundscapeTitleBreak">New York City Soundscape</span></p>
							<p id="fxTitle" style="color:white;" v-else-if="userMobile"> 
							The Sounds of New York City
						</p>
								<div class="col-xs-2" id="ambienceBtn1Div">

									<button 
										id="ambienceBtns"
										:class="ambience2Class"
										@click="ambience2Boolean = !ambience2Boolean; randomizeBoolean = false;"
										:="ambience2Func"
										> <i :class="ambience2Icon"></i>
										Humans
										</button>

										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance2RangerClass"
											v-model.number="ambience2Vol"
											:="ambience2Func"
											max="0" min="-50" step="1"
											> 				
										</input>

								</div>
								<div class="col-xs-2" id="ambienceBtn2Div">

									<button 
										id="ambienceBtns"
										:class="ambience3Class"
										@click="ambience3Boolean = !ambience3Boolean; randomizeBoolean = false;"
										:="ambience3Func"
										> <i :class="ambience3Icon"></i>
										Subway Station
										</button>
										
										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance3RangerClass"
											v-model.number="ambience3Vol"
											:="ambience3Func"
											max="0" min="-50" step="1"
											>
										</input>
								</div>

								<div class="col-xs-2" id="ambienceBtn3Div">

									<button 
										id="ambienceBtns"
										:class="ambience4Class"
										@click="ambience4Boolean = !ambience4Boolean; randomizeBoolean = false;"
										:="ambience4Func"
										> <i :class="ambience4Icon"></i>
										Subway Car
										</button>
										
										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance4RangerClass"
											v-model.number="ambience4Vol"
											:="ambience4Func"
											max="4" min="-50" step="1"
											>
										</input>
								</div>
								<div class="col-xs-2" id="ambienceBtn4Div">

									<button 
										id="ambienceBtns"
										:class="ambience1Class"
										@click="ambience1Boolean = !ambience1Boolean; randomizeBoolean = false;"
										:="ambience1Func"
										> <i :class="ambience1Icon" />
										Street
										</button>

										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance1RangerClass"
											v-model.number="ambience1Vol"
											:="ambience1Func"
											max="6" min="-50" step="1"
											>	
										</input>

								</div>

								<div class="col-xs-2" id="ambienceBtn5Div">

									<button 
										id="ambienceBtns"
										:class="ambience5Class"
										@click="ambience5Boolean = !ambience5Boolean; randomizeBoolean = false;"
										:="ambience5Func"
										> <i :class="ambience5Icon"></i>
										8th Floor
										</button>
										
										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance5RangerClass"
											v-model.number="ambience5Vol"
											:="ambience5Func"
											max="6" min="-50" step="1"
											>
										</input>
								</div>

								<div class="col-xs-2" id="ambienceBtn6Div">

									<button 
										id="ambienceBtns"
										:class="ambience6Class"
										@click="ambience6Boolean = !ambience6Boolean; randomizeBoolean = false;"
										:="ambience6Func"
										> <i :class="ambience6Icon"></i>
										Penthouse
										</button>
										
										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance6RangerClass"
											v-model.number="ambience6Vol"
											:="ambience6Func"
											max="10" min="-50" step="1"
											>
										</input>
								</div>
			</div>
		<div id="masterControlDiv">
			<p id="fxTitle2" style="color:black;"  v-show="!userMobile"> 
			Process Soundscape With Digital Audio Processing
			</p>
				<div class="col-xs-2" id="voice1SliderDiv" >
						<button id="masterControlBadges" 
										class="voiceBadgeNYC"
										@click="speedToggle = !speedToggle"
										>
										<span v-show="speedToggle" style="color:var(--main-startNYC-color)">
										<i class="far fa-check-circle"></i>
										Speed {{((playBackSpeed).toFixed(3))}}x
										</span>
										<span v-show="!speedToggle"  style="color:var(--main-stopNYC-color)">
										<i class="far fa-times-circle"></i>
										Speed {{((playBackSpeed).toFixed(3))}}x
										</span>
						</button>
						<input 
							id="sliders6"
							type="range"
							class="instrumentRangerNYC"
							step="0.01"
							max="2" min="0.1"
							v-model.number="playBackSpeed"
							:="playbackSpeedFunc"
							>	<!-- @click="voice4DraggieClick" -->
						</input>
				</div>
				<div class="col-xs-2" id="voice2SliderDiv" v-show="!userMobile">
						<button id="masterControlBadges"
										class="voiceBadgeNYC"
										@click="fxDelayToggle = !fxDelayToggle"
										>
										<span v-show="fxDelayToggle" style="color:var(--main-startNYC-color)">
										<i class="far fa-check-circle"></i>
										Delay {{fxDelayAmt}}% 
										</span>
										<span v-show="!fxDelayToggle"  style="color:var(--main-stopNYC-color)">
										<i class="far fa-times-circle"></i>
										Delay {{fxDelayAmt}}% 
										</span>
						</button>
						<input 
							id="sliders2"
							type="range"
							class="instrumentRangerNYC"
							step="1"
							max="100" min="0"
							v-model.number="fxDelayAmt"
							:="fxDelayMix"
							>		<!-- @click="voice2DraggieClick" -->
						</input>
				</div>
				<div class="col-xs-2" id="voice3SliderDiv" v-show="!userMobile">
						<button id="masterControlBadges"
										class="voiceBadgeNYC"
										@click="fxChorusToggle = !fxChorusToggle"
										>
										<span v-show="fxChorusToggle" style="color:var(--main-startNYC-color)">
										<i class="far fa-check-circle"></i>
										Chorus {{fxChorusAmt}}% 
										</span>
										<span v-show="!fxChorusToggle"  style="color:var(--main-stopNYC-color)">
										<i class="far fa-times-circle"></i>
										Chorus {{fxChorusAmt}}% 
										</span>
						</button>	
						<input 
							id="sliders3"
							type="range"
							class="instrumentRangerNYC"
							step="1"
							max="100" min="0"
							v-model.number="fxChorusAmt"
							:="fxChorusMix"
							>	<!-- @click="voice3DraggieClick" -->
						</input>

				</div>
				<div class="col-xs-2" id="voice4SliderDiv" v-show="!userMobile">
						<button id="masterControlBadges" 
										class="voiceBadgeNYC"
										@click="fxFilterToggle = !fxFilterToggle"
										>
										<span v-show="fxFilterToggle" style="color:var(--main-startNYC-color)">
										<i class="far fa-check-circle"></i>
										Filter {{fxAutoFilterAmt}}Hz
										</span>
										<span v-show="!fxFilterToggle"  style="color:var(--main-stopNYC-color)">
										<i class="far fa-times-circle"></i>
										Filter {{fxAutoFilterAmt}}Hz
										</span>
										
						</button>	
						<input 
							id="sliders4"
							type="range"
							class="instrumentRangerNYC"
							step="1"
							max="10000" min="80"
							v-model.number="fxAutoFilterAmt"
							:="fxAutoFilterMix"
							>	<!-- @click="voice4DraggieClick" -->
						</input>
				</div>

				<div class="col-xs-2" id="voice5SliderDiv" v-show="!userMobile">
						<button id="masterControlBadges"
										class="voiceBadgeNYC"
										@click="fxConvolverToggle = !fxConvolverToggle"
										>
										<span v-show="fxConvolverToggle" style="color:var(--main-startNYC-color)">
										<i class="far fa-check-circle"></i>
										Reverb ({{((fxDecay).toPrecision(2))}}s) {{(fxConvolverAmt * 2)}}%
										</span>
										<span v-show="!fxConvolverToggle"  style="color:var(--main-stopNYC-color)">
										<i class="far fa-times-circle"></i>
										Reverb ({{((fxDecay).toPrecision(2))}}s) {{(fxConvolverAmt * 2)}}%
										</span>
										
						</button>
						<input
							id="sliders1" 
							type="range"
							class="instrumentRangerNYC"
							step="1"
							max="50" min="0"
							v-model.number="fxConvolverAmt"
							:="fxConvolverMix"
							>
						</input>
				</div>

				<div class="col-xs-2" id="voice6SliderDiv">
						<button id="masterControlBadgesSFX" 
								:class="mattChillClass"
								@click="mattChillMethod"
								>
								<span v-show="!randomizeBoolean">
								<i class="fa fa-flask"></i> Randomize <i class="fa fa-flask"></i>
								</span>
								<span v-show="randomizeBoolean">
								<i v-show="showFlask5" class="fa fa-flask fa-counter-spin"></i>
								<i v-show="showFlask3" class="fa fa-flask fa-spin"></i>
								<i v-show="showFlask1" class="fa fa-flask slow-spin"></i>
								<i v-show="showFlask2" class="fa fa-flask slow-spin"></i>
								<i v-show="showFlask4" class="fa fa-flask fa-spin"></i>
								<i v-show="showFlask6" class="fa fa-flask fa-counter-spin"></i>
								</span>
						</button>
				</div>
			</div>
		</div>
		</transition>
<!-- ABOUT 					  -->
	<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated fadeOut"  
					mode="out-in">
		<div class="col-xs-12" id="aboutPageID" v-show="showAboutPage">

						<p id="aboutTxt" style="color: black;">  
						<br>
						<br>
						New York City is a sonic cake. So many layers of sound all compete, contrast, and distort one another. <strong>Humans</strong> make up the majority of sound sources in this soundscape.
						<br>
						<br>
						Deep underground is a maze of <strong>subway stations</strong>, each with a unique sonic signature. Low end rumbles resonate through the tunnels competing with high pitched screeches. 
						<br>
						<br>
						Going up a the subway's stairs, you find yourself <strong>street level</strong>. Much like a forest floor, the street level is a constant source of sound. 
						<br>
						<br>
						Rising up one more level, you may find yourself on the <strong>8th floor</strong> above the street. Up here you will still hear the street noise, but it is much less direct and often muffled. Akin to being in the trees of a NYC. 
						<br>
						<br>
						Rising to the very top of a skyscraper, you may find yourself in a <strong>penthouse</strong>. This gives you a unique sonic perspective, a respite from the chaos.  
						</p>

						<p id="disclaimerTxt" style="color: black;">
						Sound Design & Recordings Copyright © 2018 <a style="color: black;" href="https://www.mattmccorkle.com" target="_blank">Matt McCorkle</a>
						<br>
						<strong> These sounds are presented here for personal entertainment use only. </strong>
						<br>
						For commercial sound licensing email hi@mattmccorkle.com
						</p>

						</p>
						<button
							id="aboutBtnID2"
							:class="helpClass"
							class="btn btn-info"
							@click="goToHelp">
							<strong><i class="fa fa-window-close fa-3x" /></strong>
						</button>
		</div>
	</transition>
<!-- SPEECH RECONGIZATION 	  -->
	<div v-if="this.$store.state.allowSpeechControl">	
		<!-- <transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated pulse"  
					mode="out-in"
					>	
			<div class="container-fluid" id="speechContainer" v-if="showSpeechBtns">	
				<button 
					v-if="initSpeech"
					id="speechEngage"
					:class="speechStartStopClass"
					@click="speechFunc"
					> <i class="fal fa-microphone-slash"></i> Engage Voice Commands
				</button>
				<button 
					v-if="!initSpeech"
					id="speechEngage"
					:class="speechStartStopClass"
					@click="speechStartStopFunc"
					> 	<i :class="speechIconClass" /> {{speechBtnTxt}}
				</button>
			</div>
		</transition> -->
	</div>
<!-- VOICE COMMAND LIST 	  -->
	<div v-if="this.$store.state.allowSpeechControl">	
		<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated pulse"  
					mode="out-in"
					>	
				
			<div class="container-fluid" id="speechContainer" v-if="showSpeechBtns">	
				<button 
					id="speechList"
					:class="speechShowListClass"
					@click="voiceCommandListFunc"
					> <i class="fal fa-clipboard-list"></i> List of Voice Commands
				</button>
				<div v-if="showVoiceCommandList" id="voiceCommandListID">
					<p id="voiceControlListTitle"> <strong> Voice Control This Immersive Experience</strong></p>
				<p id="voiceControlListTxt">	
					<strong>Allow Google Chrome Microphone Access To Use This Feature</strong> 
					<br>
					<i class="fal fa-headphones"></i> Voice Control Works <strong><u>Great</u></strong> With Headphones <i class="fal fa-headphones"></i>
					<br>
					<br>
					<strong>OK! Now Use That Beautiful Voice, Say Something!
					<br>
					<br>
					<u>Exploration:</u>
					<br>
					Let's Explore!
					<br>
					Randomize, Shift Soundscape,</strong> or <strong>New Scene</strong>
					<br>
					<br>
					<strong><u>Creating A Soundscape:</u></strong>
					<br>
					<strong>Play</strong> or <strong>Add In</strong> <i>Humans</i><br>
					<strong>Play</strong> or <strong>Add In</strong> <i>Subway Station</i><br>
					<strong>Play</strong> or <strong>Add In</strong> <i>Subway Car</i><br>
					<strong>Play</strong> or <strong>Add In</strong> <i>Street</i><br>
					<strong>Play</strong> or <strong>Add In</strong> <i>8th Floor</i><br>
					<strong>Play</strong> or <strong>Add In</strong> <i>Penthouse</i><br>
					<br>
					<strong>Stop </strong> or <strong>Take Out </strong>[Sound Source Name] 
					<br><span id="voiceListAnchor" />
					<strong>Volume Up</strong> or <strong>Louder</strong> [Sound Source Name]
					<br>
					<strong>Volume Down</strong> or <strong>Softer </strong>[Sound Source Name]
					<br>
					<br>
					<strong><u>Digital Audio Effects:</u></strong>
					<br>
					<strong>Speed Up </strong>or <strong>Faster</strong> & <strong>Speed Down </strong>or <strong>Slower</strong>
					<br>
					<strong>Delay On</strong> or <strong>Off </strong> & <strong>More </strong>or <strong>Less</strong>
					<br> 
					<strong>Chorus On</strong> or <strong>Off </strong> & <strong>More </strong>or <strong>Less</strong>
					<br> 
					<strong>Filter On</strong> or <strong>Off </strong> & <strong>More </strong>or <strong>Less</strong>
					<br> 
					<strong>Reverb On</strong> or <strong>Off </strong> & <strong>More </strong>or <strong>Less</strong>
					<br> 
					<i>Add the word <strong>a lot</strong> to move in greater increments.</i>
					<br>
					<br>
					<strong><u>Housekeeping:</u>
					<br>
					Stop All Sounds 
					<br> 
					Play All Sounds
					<br>
					Stop Voice Commands 
					<br> 
					Go Home
					<br>
					Show</strong> or <strong>Hide Soundscape Info
					<br>
					Show</strong> or <strong>Hide Voice Command List</strong>
					<br>
					<br>
					<strong><u>Additional Mentions:</u></strong>
					<br>
					1.) It might take a few tries, try saying your command quickly and in a direct manner.
					<br>
					<br>
					2.) Each Sound Source can always be addressed as "Sound Source 1-6"
				</p>
				</div>
			</div>
		</transition>
	</div>
<!-- EXPLORE BTN    		  -->
	<div v-if="!this.$store.state.allowSpeechControl">
		<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated fadeOut"  
					mode="out-in"
					>	
			<div class="container-fluid" v-show="showNavBar">
				<button 
						id="exploreBtnId"
						:class="exploreFuncClass"
						@click="exploreBtnFunc"
						> <i :class="exploreIconClass"></i> {{exploreTxt}}
				</button>
			</div>
		</transition>
	</div>
<!-- WHAT IS THIS BUTTON      -->
		<transition-group
					enter-active-class="animated fadeIn"
					leave-active-class="animated fadeOut"  
					mode="out-in"
					>		
			<div class="container-fluid" v-show="showNavBar"  id="helpContainer" key="localStorageBtnsKey">	
				<div class="col-xs-6">
					<button
							id="localStorageBtnID"
							:class="saveClass"
							@click="setLocalStorage">
					<i class="fal fa-sliders-h"></i> Save
					</button>
				</div>
				<div class="col-xs-6">
					<button
							id="localStorageBtnID"
							:class="loadClass"
							@click="getLocalStorage">
					<i class="fal fa-sliders-h"></i> Load
					</button>
				</div>	
			</div>	
			<div class="container-fluid" v-show="showNavBar"  id="helpContainer" key="helpBtnsKeys">	
				<div class="col-xs-6">
					<button
							id="aboutBtnID"
							:class="helpClass"
							@click="goToHelp">
					<i class="fal fa-info-circle"></i> Info
					</button>
				</div>
				<div class="col-xs-6">
					<button
							id="aboutBtnID"
							:class="helpClass"
							@click="goHome">
					<i class="fas fa-home"></i> Home
					</button>
				</div>	
			</div>	
		</transition-group>
<!-- VISUAL TOGGLE 			  -->
		<div v-if="!userMobile">
			<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated fadeOut"  
					mode="out-in"
					>	
				<div class="container-fluid" id="visualToggleContainer" v-show="showNavBar">
					<span v-if="activeSun" id="visualToggle" @click="activeSun = !activeSun"> 
						Reactive Background
						<i class="fal fa-toggle-on"></i>
					</span>
					<span v-else-if="!activeSun" id="visualToggle" @click="activeSun = !activeSun"> 
						Reactive Background
						<i class="fal fa-toggle-off"></i>
					</span>
				</div>
			</transition>
		</div>
<!-- END --> 
	</div>
</template>

<script>
import StartAudioContext from '../../node_modules/startaudiocontext/StartAudioContext.js'
import Tone from '../../node_modules/Tone/build/Tone.min.js'
const XRegExp = require('xregexp');
	export default {
data: () => ({
		//RANDOMIZE BOOLEANS
			randomizeBoolean:   false,
			showFlask1:         true,
			showFlask2:         false,
			showFlask3:         false,
			showFlask4:         false,
			showFlask5:         false,
			showFlask6:         false,
		//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			userMobile:   Boolean,
			mailingListBtn:     false,
			textTiming: 		500,
			startStopTrigger:   true,
			playColor: 			 "#F0CB50",	
			stopColor:           "#1E9BFC",
		//SCREEN DIMENSIONS
			screenHeight: 				undefined,
			screenWidth: 				undefined,
			ogWidth: 					undefined,
		//BACKGROUND COLORS
			plungeDepth:        1,
			backgroundColor1:   true,
			backgroundColor2:   false,
			backgroundColor3:   false,
			backgroundColor4:   false,
			backgroundColor5:   false,
			backgroundColor6:   false,
			backgroundColor7:   false,
			backgroundColor8:   false,
			backgroundColor9:   false,
			backgroundColor10:   false,
		//REACTIVE SUN
			sunReactiveColor1:   true,
			sunReactiveColor2:   false,
			sunReactiveColor3:   false,
			sunReactiveColor4:   false,
			sunReactiveColor5:   false,
			sunReactiveColor6:   false,
			sunReactiveColor7:   false,
			sunReactiveColor8:   false,
			sunReactiveColor9:   false,
			sunReactiveColor10:   false,
		//SHOW AND HIDE
			helpTrigger:        false,
			showHelpOverlay:   	false,
			showAboutPage:      false,

			bellBoolean:        false,
		//PLAY SUN DRAGGIE
			activeSun:          false,
		//V-SHOWS
			showEnterContainer: true,
		    showLoading:        true,
			showEnterBtn:       false,
			showNavBar:         false,
			showAllControls:    false,
			showSpeechBtns:     false,
		//AMBIENCE BOOLEANS
			ambience1Boolean:   false,
			ambience2Boolean:   false,
			ambience3Boolean:   false,
			ambience4Boolean:   false,
			ambience5Boolean:   false,
			ambience6Boolean:   false,
		//AMBIENCE DATA
			whatIsLoading:              "NYC",
			metroFX:                  	new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -5,
			  							}).toMaster(),
			changeFX:                   new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -6,
			  							}).toMaster(),
			ambience1Vol:               -10,
			ambience2Vol:               -10,
			ambience3Vol:               -10,
			ambience4Vol:               -2,
			ambience5Vol:               -10,
			ambience6Vol:               -16,
			ambience1Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"volume": 0
			  							}),
			ambience2Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"volume": 0
			  							}),
			ambience3Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"volume": 0
			  							}),
			ambience4Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"volume": 0
			  							}),
			ambience5Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"volume": 0
			  							}),
			ambience6Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"volume": 0
			  							}),
		//AUDIO ROUTING & EFFECTS
			playBackSpeed:          1,
			fxDecay:            	2.5,
			// masterVolume:     		0,
			loadingSoundID:         undefined,
			audioLoading: 			undefined,
			fxConvolverAmt:         0,
			fxChorusAmt:            0,
			fxDelayAmt:             0,
			fxAutoFilterAmt:        3500,
			mattChill:              false,
			fxConvolver:      		undefined,
			fxChorus:               undefined,
			fxDistort:              undefined,
			fxDelay:  				undefined,
			fxAutoFilter:           undefined,

			subwayFilter:           undefined,
			streetFilter:           undefined,

			speedToggle:            true,
			fxDelayToggle:      	true,
			fxConvolverToggle:      true,
			fxChorusToggle:         true,
			fxFilterToggle:         false,

			masterMeter:            undefined,
			masterLevel:            0,
			masterVolumeSub:        new Tone.Volume(0),
		//SPEECH
			//FOR SPEECH FORM INPUT
			submitSpeechTxttoVoice: false,
			userVoiceToText: "",
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl:     false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: 		false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: 			undefined,
			recognitionNYC:   	undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray:      undefined,
			speechRecognitionList:  undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI:             "",
			//BUTTON SWITCHING & TEXT
			initSpeech:             true,
			speechBtnTxt:           "Say A Command",
			speechStartTopBtnTrigger: true,
			//SHOWS LIST OF COMMANDS
			showVoiceCommandList:     false,
			//DISABLE WHILE RECORDING
			isDisableListening:     false,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech:       false,
			//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
		//EXPLORE
			isExploreFuncRunning: false,
			didWeAdventure:       false,
			exploreSound1: undefined,
			exploringInterval: undefined,
			exploreBtnBoolean: false,
		//WHAT DEVICE
			isChrome: 				Boolean,
			isFirefox: 				Boolean,
			isSafari: 				Boolean,
			isOpera: 				Boolean,
			isIE: 					Boolean,
			isEdge: 				Boolean,
			isBlink: 				Boolean,
			iOS: 					Boolean,
			AndroidMobile: 			Boolean,
		//EXPLORE TIMES OUTS
			exploreTxt:     "Explore!",
			exploreTimeout1: undefined,
			exploreTimeout2: undefined,
			exploreTimeout3: undefined,
			exploreTimeout4: undefined,
			exploreTimeout5: undefined,
			exploreTimeout6: undefined,
			exploreTimeout7: undefined,
			exploreTimeout8: undefined,
			exploreTimeout9: undefined,
			exploreTimeout10: undefined,
			exploreTimeout11: undefined,
			exploreTimeout12: undefined,
			exploreTimeout13: undefined,
			exploreTimeout14: undefined,
		//START AUDIO CONTEXT BOOLEAN
			startAudioBoolean: true,
		//LOCAL STORAGE
			isCacheSaved: false,
			firstLoad:   false,
			saveTrigger: false,
			loadTrigger: false,
		}),
created(){
	this.isVoiceControl = this.$store.state.isVoiceControlled;
	if (this.isVoiceControl){
		this.$store.state.doNotAddress = true;
	}
	
	window.onpopstate = ()=> {
		document.body.className = 'default';
		this.goHome();
	}
	let ua = window.navigator.userAgent;
        this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        this.isFirefox = typeof InstallTrigger !== 'undefined';
        this.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
        this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        this.isIE = /*@cc_on!@*/false || !!document.documentMode;
        this.isEdge = !this.isIE && !!window.StyleMedia;
        this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS,
        this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        this.AndroidMobile = /Android/i.test(navigator.userAgent);
        //CHROME ALLOWS SPEECH AND MEDIA RECORDING
		if (this.isChrome === true){
			this.userMobile = false;
		//FIREFOX ONLY ALLOWS MEDIA RECORDING
		} else if (this.isFirefox === true){
			this.userMobile = false;
		//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
		} else if (this.AndroidMobile === true 
				|| this.iOS){
			this.userMobile = true;
		} else if (this.isSafari === true 
				|| this.isOpera === true 
				|| this.isBlink === true 
				|| this.isEdge === true 
				|| this.isIE === true){
			this.userMobile = false;
		}
	this.firstAudioLoadFunc();
	this.bufferLoading();
	this.audioRouting();
},
computed:{
	//THE PLUNGE BACKGROUND CHANGE
		plungeClass(){
		if (this.activeSun === false){
				if (this.plungeDepth === 1){
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = true;
				} else if (this.plungeDepth === 2){
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = true;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 3){
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = true;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 4){
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = true;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 5){
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = true;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 6){
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = true;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 7){
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = true;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 8){
					this.backgroundColor10 = false;
					this.backgroundColor9 = false;
					this.backgroundColor8 = true;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 9){
					this.backgroundColor10 = false;
					this.backgroundColor9 = true;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} else if (this.plungeDepth === 10){
					this.backgroundColor10 = true;
					this.backgroundColor9 = false;
					this.backgroundColor8 = false;
					this.backgroundColor7 = false;
					this.backgroundColor6 = false;
					this.backgroundColor5 = false;
					this.backgroundColor4 = false;
					this.backgroundColor3 = false;
					this.backgroundColor2 = false;
					this.backgroundColor1 = false;
				} 
				return{
							"backgroundColorNYC10": this.backgroundColor10,
							"backgroundColorNYC9": this.backgroundColor9,
							"backgroundColorNYC8": this.backgroundColor8,
							"backgroundColorNYC7": this.backgroundColor7,
							"backgroundColorNYC6": this.backgroundColor6,
							"backgroundColorNYC5": this.backgroundColor5,
							"backgroundColorNYC4": this.backgroundColor4,
							"backgroundColorNYC3": this.backgroundColor3,
							"backgroundColorNYC2": this.backgroundColor2,
							"backgroundColorNYC1": this.backgroundColor1
				}
		} else if (this.activeSun === true){
			if (this.masterLevel < -36){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = true;
			} else if (this.masterLevel < -32){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = true;
				this.sunReactiveColor1 = false;
			} else if (this.masterLevel < -30){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = true;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = false;
			} else if (this.masterLevel < -28){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = true;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = false;
			} else if (this.masterLevel < -26){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = true;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = false;
			} else if (this.masterLevel < -24){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = true;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = false;
			} else if (this.masterLevel < -22){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = true;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = false;
			} else if (this.masterLevel < -20){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = true;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = false;
			} else if (this.masterLevel < -18){
				this.sunReactiveColor10 = false;
				this.sunReactiveColor9 = true;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = false;
			} else if (this.masterLevel > -16){
				this.sunReactiveColor10 = true;
				this.sunReactiveColor9 = false;
				this.sunReactiveColor8 = false;
				this.sunReactiveColor7 = false;
				this.sunReactiveColor6 = false;
				this.sunReactiveColor5 = false;
				this.sunReactiveColor4 = false;
				this.sunReactiveColor3 = false;
				this.sunReactiveColor2 = false;
				this.sunReactiveColor1 = false;
			} 
			return{
						"sunReactiveColorClassNYC10": this.sunReactiveColor10,
						"sunReactiveColorClassNYC9": this.sunReactiveColor9,
						"sunReactiveColorClassNYC8": this.sunReactiveColor8,
						"sunReactiveColorClassNYC7": this.sunReactiveColor7,
						"sunReactiveColorClassNYC6": this.sunReactiveColor6,
						"sunReactiveColorClassNYC5": this.sunReactiveColor5,
						"sunReactiveColorClassNYC4": this.sunReactiveColor4,
						"sunReactiveColorClassNYC3": this.sunReactiveColor3,
						"sunReactiveColorClassNYC2": this.sunReactiveColor2,
						"sunReactiveColorClassNYC1": this.sunReactiveColor1
			}
		}
		},
	//SHOW AND HIDE CLASS CHANGES
					helpClass(){
						return{
							"btn btn-helpBtn1NYC": this.helpTrigger,
							"btn btn-helpBtn2NYC": !this.helpTrigger,
						}
					},
					mailingListBtnClass(){
						return{
							"btn btn-transparent": this.mailingListBtn,
							"btn btn-info": !this.mailingListBtn,
						}	
					},
	//AMBIENCE CLASS CHANGES
					ambience1Class(){
						return{
							"btn btn-playNYC": this.ambience1Boolean,
							"btn btn-stopNYC": !this.ambience1Boolean,
						}
					},
					ambience2Class(){
						return{
							"btn btn-playNYC": this.ambience2Boolean,
							"btn btn-stopNYC": !this.ambience2Boolean,
						}
					},
					ambience3Class(){
						return{
							"btn btn-playNYC": this.ambience3Boolean,
							"btn btn-stopNYC": !this.ambience3Boolean,
						}
					},
					ambience4Class(){
						return{
							"btn btn-playNYC": this.ambience4Boolean,
							"btn btn-stopNYC": !this.ambience4Boolean,
						}
					},
					ambience5Class(){
						return{
							"btn btn-playNYC": this.ambience5Boolean,
							"btn btn-stopNYC": !this.ambience5Boolean,
						}
					},
					ambience6Class(){
						return{
							"btn btn-playNYC": this.ambience6Boolean,
							"btn btn-stopNYC": !this.ambience6Boolean,
						}
					},
					mattChillClass(){
						return {
							"btn btn-mattChillOnNYC": this.mattChill,
							"btn btn-mattChillOffNYC": !this.mattChill
						}
					},
	//AMBIENCE ICON CSS
					ambience1Icon(){
						return {
							"fal fa-times-circle": !this.ambience1Boolean,
							"fal fa-check-circle": this.ambience1Boolean
						}
					},
					ambience2Icon(){
						return {
							"fal fa-times-circle": !this.ambience2Boolean,
							"fal fa-check-circle": this.ambience2Boolean
						}
					},
					ambience3Icon(){
						return {
							"fal fa-times-circle": !this.ambience3Boolean,
							"fal fa-check-circle": this.ambience3Boolean
						}
					},
					ambience4Icon(){
						return {
							"fal fa-times-circle": !this.ambience4Boolean,
							"fal fa-check-circle": this.ambience4Boolean
						}
					},
					ambience5Icon(){
						return {
							"fal fa-times-circle": !this.ambience5Boolean,
							"fal fa-check-circle": this.ambience5Boolean
						}
					},
					ambience6Icon(){
						return {
							"fal fa-times-circle": !this.ambience6Boolean,
							"fal fa-check-circle": this.ambience6Boolean
						}
					},	
	//AMBIANCE CLASS CHANGES
					ambiance1RangerClass(){
						return{
							"ambianceRangerPlayNYC": this.ambience1Boolean,
							"ambianceRangerStopNYC": !this.ambience1Boolean,
							}
					},
					ambiance2RangerClass(){
						return{
							"ambianceRangerPlayNYC": this.ambience2Boolean,
							"ambianceRangerStopNYC": !this.ambience2Boolean,
							}
					},
					ambiance3RangerClass(){
						return{
							"ambianceRangerPlayNYC": this.ambience3Boolean,
							"ambianceRangerStopNYC": !this.ambience3Boolean,
							}
					},
					ambiance4RangerClass(){
						return{
							"ambianceRangerPlayNYC": this.ambience4Boolean,
							"ambianceRangerStopNYC": !this.ambience4Boolean,
							}
					},
					ambiance5RangerClass(){
						return{
							"ambianceRangerPlayNYC": this.ambience5Boolean,
							"ambianceRangerStopNYC": !this.ambience5Boolean,
							}
					},
					ambiance6RangerClass(){
						return{
							"ambianceRangerPlayNYC": this.ambience6Boolean,
							"ambianceRangerStopNYC": !this.ambience6Boolean,
							}
					},
	//AUDIO MIXING
		adjustInputVolume(){
			this.userMic.volume.value = this.userMicInputLevel;
		},
		fxConvolverMix(){
			if (this.userMobile === false){
				if (this.fxConvolverToggle === true){
					this.fxConvolver.wet.setTargetAtTime((this.fxConvolverAmt / 100), Tone.Context.currentTime, +0.1);
				} else if (this.fxConvolverToggle === false){ 
					this.fxConvolver.wet.setTargetAtTime(0, Tone.Context.currentTime, +0.1);
				}
			}
		},
		fxDelayMix(){
			if (this.userMobile === false){
				if (this.fxDelayToggle === true){
					this.fxDelay.wet.setTargetAtTime((this.fxDelayAmt / 100), Tone.Context.currentTime, +1);
				} else if (this.fxDelayToggle === false){ 
					this.fxDelay.wet.setTargetAtTime(0, Tone.Context.currentTime, +1);
				}
			}
		},
		fxChorusMix(){
			if (this.userMobile === false){
				if (this.fxChorusToggle === true){
					this.fxChorus.wet.setTargetAtTime((this.fxChorusAmt / 100), Tone.Context.currentTime, +0.1);
				} else if (this.fxChorusToggle === false){ 
					this.fxChorus.wet.setTargetAtTime(0, Tone.Context.currentTime, +0.1);
				}
			}
		},
		fxAutoFilterMix(){
			if (this.userMobile === false){
				if (this.fxFilterToggle === true){
					this.fxAutoFilter.frequency.setTargetAtTime(this.fxAutoFilterAmt, Tone.Context.currentTime, +0.1);
				} else if (this.fxFilterToggle === false){ 
					this.fxAutoFilter.frequency.setTargetAtTime(20000, Tone.Context.currentTime, +0.1);
				}
			}
		},
		playbackSpeedFunc(){
			if (this.speedToggle === true){
			this.ambience1Player.playbackRate = this.playBackSpeed;
			this.ambience2Player.playbackRate = this.playBackSpeed;
			this.ambience3Player.playbackRate = this.playBackSpeed;
			this.ambience4Player.playbackRate = this.playBackSpeed;
			this.ambience5Player.playbackRate = this.playBackSpeed;
			this.ambience6Player.playbackRate = this.playBackSpeed;
			} else if (this.speedToggle === false){
			this.ambience1Player.playbackRate = 1;
			this.ambience2Player.playbackRate = 1;
			this.ambience3Player.playbackRate = 1;
			this.ambience4Player.playbackRate = 1;
			this.ambience5Player.playbackRate = 1;
			this.ambience6Player.playbackRate = 1;
			}
		},
	//SPEECH
		speechStartStopClass(){
			return {
				"recordingClassEngagedNYC": this.recognizing,
				"recordingClassDisengagedNYC": !this.recognizing
			}
		},
		speechIconClass(){
			return {
				"fa fa-microphone-alt fa-spin": this.recognizing,
				"fa fa-microphone-alt": !this.recognizing
			}
		},
		speechShowListClass(){
			return {
				"recordingClassEngagedNYC": this.showVoiceCommandList,
				"recordingClassDisengagedNYC": !this.showVoiceCommandList
			}
		},
		speechSubmitClass(){
			return {
				"btn btn-speechSubmitOn mb-2": this.submitSpeechTxttoVoice,
				"btn btn-speechSubmitOff mb-2": !this.submitSpeechTxttoVoice,
			}
		},
	//EXPLORE
		exploreFuncClass(){
			return {
				"recordingClassDisengagedNYC": !this.isExploreFuncRunning,
				"recordingClassEngagedNYC": this.isExploreFuncRunning,
			}
		},
		exploreIconClass(){
			return {
				"fab fa-wpexplorer": !this.isExploreFuncRunning,
				"fab fa-wpexplorer fa-spin": this.isExploreFuncRunning,
			}
		},
	//AMBIENCE PLAY AND STOPS
					ambience1Func(){
						if (this.ambience1Boolean === true){
							this.ambience1Player.volume.value = this.ambience1Vol;
						} else if (this.ambience1Boolean === false){
							this.ambience1Player.volume.setTargetAtTime(-70, 
												Tone.Context.currentTime, +0.05);
						}
					},
					ambience2Func(){
						if (this.ambience2Boolean === true){
							this.ambience2Player.volume.value = this.ambience2Vol;
						} else if (this.ambience2Boolean === false){
							this.ambience2Player.volume.setTargetAtTime(-70, 
												Tone.Context.currentTime, +0.05);
						}
					},
					ambience3Func(){
						if (this.ambience3Boolean === true){
							this.ambience3Player.volume.value = this.ambience3Vol;
						} else if (this.ambience3Boolean === false){
							this.ambience3Player.volume.setTargetAtTime(-70, 
												Tone.Context.currentTime, +0.05);
						}
					},
					ambience4Func(){
						if (this.ambience4Boolean === true){
							this.ambience4Player.volume.value = this.ambience4Vol;
						} else if (this.ambience4Boolean === false){
							this.ambience4Player.volume.setTargetAtTime(-70, 
												Tone.Context.currentTime, +0.05);
						}
					},
					ambience5Func(){
						if (this.ambience5Boolean === true){
							this.ambience5Player.volume.value = this.ambience5Vol;
						} else if (this.ambience5Boolean === false){
							this.ambience5Player.volume.setTargetAtTime(-70, 
												Tone.Context.currentTime, +0.05);
						}
					},
					ambience6Func(){
						if (this.ambience6Boolean === true){
							this.ambience6Player.volume.value = this.ambience6Vol;
						} else if (this.ambience6Boolean === false){
							this.ambience6Player.volume.setTargetAtTime(-70, 
												Tone.Context.currentTime, +0.05);
						}
					},
	//LOCAL STORAGE
		saveClass(){
			return{"btn btn-playNYC": this.saveTrigger,
					"btn btn-stopNYC": !this.saveTrigger}
		},
		loadClass(){
			return{"btn btn-playNYC": this.loadTrigger,
					"btn btn-stopNYC": !this.loadTrigger}
		},
	},
methods: {
	//LOCAL STORAGE
		setLocalStorage(){
			this.saveTrigger = true;
			setTimeout(()=>{this.saveTrigger = false}, 250);

			this.removeLocalStorage();

			localStorage.setItem('isCacheSavedNYC', JSON.stringify(true));

			localStorage.setItem('ambience1VolNYC', JSON.stringify(this.ambience1Vol));
			localStorage.setItem('ambience2VolNYC', JSON.stringify(this.ambience2Vol));
			localStorage.setItem('ambience3VolNYC', JSON.stringify(this.ambience3Vol));
			localStorage.setItem('ambience4VolNYC', JSON.stringify(this.ambience4Vol));
			localStorage.setItem('ambience5VolNYC', JSON.stringify(this.ambience5Vol));
			localStorage.setItem('ambience6VolNYC', JSON.stringify(this.ambience6Vol));

			localStorage.setItem('ambience1BooleanNYC', JSON.stringify(this.ambience1Boolean));
			localStorage.setItem('ambience2BooleanNYC', JSON.stringify(this.ambience2Boolean));
			localStorage.setItem('ambience3BooleanNYC', JSON.stringify(this.ambience3Boolean));
			localStorage.setItem('ambience4BooleanNYC', JSON.stringify(this.ambience4Boolean));
			localStorage.setItem('ambience5BooleanNYC', JSON.stringify(this.ambience5Boolean));
			localStorage.setItem('ambience6BooleanNYC', JSON.stringify(this.ambience6Boolean));

			localStorage.setItem('speedToggleNYC', JSON.stringify(this.speedToggle));
			localStorage.setItem('fxDelayToggleNYC', JSON.stringify(this.fxDelayToggle));
			localStorage.setItem('fxConvolverToggleNYC', JSON.stringify(this.fxConvolverToggle));
			localStorage.setItem('fxChorusToggleNYC', JSON.stringify(this.fxChorusToggle));
			localStorage.setItem('fxFilterToggleNYC', JSON.stringify(this.fxFilterToggle));

			localStorage.setItem('playBackSpeed', JSON.stringify(this.playBackSpeed));
			localStorage.setItem('fxConvolverAmtNYC', JSON.stringify(this.fxConvolverAmt));
			localStorage.setItem('fxChorusAmtNYC', JSON.stringify(this.fxChorusAmt));
			localStorage.setItem('fxDelayAmtNYC', JSON.stringify(this.fxDelayAmt));
			localStorage.setItem('fxAutoFilterAmtNYC', JSON.stringify(this.fxAutoFilterAmt));
		},
		getLocalStorage(){
			this.isCacheSaved = JSON.parse(localStorage.getItem('isCacheSavedNYC'));
			if(this.isCacheSaved){
				this.loadTrigger = true;
				setTimeout(()=>{this.loadTrigger = false}, 250);

				this.ambience1Vol = JSON.parse(localStorage.getItem('ambience1VolNYC'));
				this.ambience2Vol = JSON.parse(localStorage.getItem('ambience2VolNYC'));
				this.ambience3Vol = JSON.parse(localStorage.getItem('ambience3VolNYC'));
				this.ambience4Vol = JSON.parse(localStorage.getItem('ambience4VolNYC'));
				this.ambience5Vol = JSON.parse(localStorage.getItem('ambience5VolNYC'));
				this.ambience6Vol = JSON.parse(localStorage.getItem('ambience6VolNYC'));

				this.ambience1Boolean = JSON.parse(localStorage.getItem('ambience1BooleanNYC'));
				this.ambience2Boolean = JSON.parse(localStorage.getItem('ambience2BooleanNYC'));
				this.ambience3Boolean = JSON.parse(localStorage.getItem('ambience3BooleanNYC'));
				this.ambience4Boolean = JSON.parse(localStorage.getItem('ambience4BooleanNYC'));
				this.ambience5Boolean = JSON.parse(localStorage.getItem('ambience5BooleanNYC'));
				this.ambience6Boolean = JSON.parse(localStorage.getItem('ambience6BooleanNYC'));

				this.speedToggle = JSON.parse(localStorage.getItem('speedToggleNYC'));
				this.fxDelayToggle = JSON.parse(localStorage.getItem('fxDelayToggleNYC'));
				this.fxConvolverToggle = JSON.parse(localStorage.getItem('fxConvolverToggleNYC'));
				this.fxChorusToggle = JSON.parse(localStorage.getItem('fxChorusToggleNYC'));
				this.fxFilterToggle = JSON.parse(localStorage.getItem('fxFilterToggleNYC'));

				this.playBackSpeed = JSON.parse(localStorage.getItem('playBackSpeed'));;
				this.fxConvolverAmt = JSON.parse(localStorage.getItem('fxConvolverAmtNYC'));
				this.fxChorusAmt = JSON.parse(localStorage.getItem('fxChorusAmtNYC'));
				this.fxDelayAmt = JSON.parse(localStorage.getItem('fxDelayAmtNYC'));
				this.fxAutoFilterAmt = JSON.parse(localStorage.getItem('fxAutoFilterAmtNYC'));
			}
		},
		removeLocalStorage(){
			localStorage.removeItem('isCacheSavedNYC');

	        localStorage.removeItem('ambience1VolNYC');
	        localStorage.removeItem('ambience2VolNYC');
	        localStorage.removeItem('ambience3VolNYC');
	        localStorage.removeItem('ambience4VolNYC');
	        localStorage.removeItem('ambience5VolNYC');
	        localStorage.removeItem('ambience6VolNYC');

	        localStorage.removeItem('ambience1BooleanNYC');
			localStorage.removeItem('ambience2BooleanNYC');
			localStorage.removeItem('ambience3BooleanNYC');
			localStorage.removeItem('ambience4BooleanNYC');
			localStorage.removeItem('ambience5BooleanNYC');
			localStorage.removeItem('ambience6BooleanNYC');

        	localStorage.removeItem('speedToggleNYC');
		    localStorage.removeItem('fxDelayToggleNYC');
			localStorage.removeItem('fxConvolverToggleNYC');
			localStorage.removeItem('fxChorusToggleNYC');
			localStorage.removeItem('fxFilterToggleNYC');

		    localStorage.removeItem('playBackSpeedNYC');
			localStorage.removeItem('fxConvolverAmtNYC');
         	localStorage.removeItem('fxChorusAmtNYC');         
         	localStorage.removeItem('fxDelayAmtNYC');
			localStorage.removeItem('fxAutoFilterAmtNYC');
		},
	//START AUDIO
			startAudio(){
				if (this.firstLoad){
						this.firstLoad = false;
						StartAudioContext(Tone.context, "#enterFuncBtn");
						this.$store.state.hasAudioContextTriggered = true;
				}
				this.ambience1Player.volume.value = -100;
				this.ambience2Player.volume.value = -100;
				this.ambience3Player.volume.value = -100;
				this.ambience4Player.volume.value = -100;
				this.ambience5Player.volume.value = -100;
				this.ambience6Player.volume.value = -100;
				
				this.ambience1Player.start();
				this.ambience2Player.start();
				this.ambience3Player.start();
				this.ambience4Player.start();
				this.ambience5Player.start();
				this.ambience6Player.start();
			},	
			stopAudio(){
				this.ambience1Player.stop();
				this.ambience2Player.stop();
				this.ambience3Player.stop();
				this.ambience4Player.stop();
				this.ambience5Player.stop();
				this.ambience6Player.stop();	
			},		 
	//SPEECH
		userVoiceToTextFunc(){
			this.submitSpeechTxttoVoice = true;
			this.testObjectVUI = this.userVoiceToText;
			console.log(this.testObjectVUI);
			this.sourceSortingVUI();
			setTimeout(()=>{this.submitSpeechTxttoVoice = false}, 250);
		},
		speechFunc(){
			if (this.initSpeech === true ){
					this.recognitionNYC = new webkitSpeechRecognition();
					this.recognizing;
					this.recognitionNYC.continuous = false;
					this.recognitionNYC.interimResults = true;
				
					this.recognitionNYC.onresult = (event)=> {
					  for (let i = event.resultIndex; i < event.results.length; ++i) {
					    if (event.results[i].isFinal) {
					    	if (!this.isDisableListening){	
					    		this.testObjectVUI += (event.results[i][0].transcript);
					    		console.log('Speech String Command: ' + (event.results[i][0].transcript));
					    		this.sourceSortingVUI();
					  		} 
					    }
					  }
					}
					this.recognitionNYC.onspeechend =  ()=> {
							console.log('%c NYC Module SPEECH Ended', 'background: red; color: black');
							// setTimeout(this.sourceSortingVUI, 500);
							this.recognizing = false;
							this.speechBtnTxt = "Say A Command";
							Tone.Master.volume.setTargetAtTime(0, Tone.context.currentTime, +0.5);
					} 
					this.recognitionNYC.onspeechstart = ()=> {
							console.log('%c NYC Module SPEECH Began', 'background: green; color: white');
							this.recognizing = true;
							this.speechBtnTxt = "Listening For Command";
							Tone.Master.volume.setTargetAtTime(-10, Tone.context.currentTime, +1);
					}
					this.recognitionNYC.onsoundstart = ()=> {
						console.log('%c NYC Module LISTENING Began', 'background: green; color: white');
					} 
					this.recognitionNYC.onaudioend = ()=> {
						console.log('%c NYC Module LISTENING Ended', 'background: green; color: white');
						// setTimeout(this.sourceSortingVUI, 500);
							this.recognizing = false;
							this.speechBtnTxt = "Say A Command";
					} 
					this.recognitionNYC.onend = ()=> {
						console.log('%c NYC Module SPEECH SESSION ENDED', 'background: green; color: white');
							if (this.stopModuleSpeech === false){
									this.recognitionNYC.start();
								}
					} 
				this.recognizing = true;
				//MAKE SURE SPEECH IS NOT RE-ENGAGED
				this.initSpeech = false;
				//GLOBAL VOICE COMMAND IS SET TO TRUE
				this.$store.state.isVoiceControlled = true;
				this.recognitionNYC.start();
				//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
				this.goingHomeNotViaVoiceCommand = true;
				//CONTROLS recognition.onend TO RESTART LISTENING
				this.stopModuleSpeech = false;
				//TURN LISTENING BACK ON
				this.isDisableListening = false;
				//IF BEING VOICE CONTROLLED DON'T PLAY THE NICE, TELL ME WHERE YOU WANT TO GO PROMPT ON WELCOME PAGE
				this.$store.state.doNotAddress = true;
			} else if (this.initSpeech === false){
				
			}
		},
		resetFunc(){
			this.recognizing = false;
		},
		speechStartStopFunc(){
			this.speechStartTopBtnTrigger = !this.speechStartTopBtnTrigger;

			if (this.speechStartTopBtnTrigger === true){
				this.speechFunc();
			} else if (this.speechStartTopBtnTrigger === false){
				this.initSpeech = true;
				this.stopModuleSpeech = true;
				this.recognizing = false;
				this.recognitionNYC.stop();
				this.$store.state.isVoiceControlled = false;

			}
		},
		sourceSortingVUI(){	
			//FOR VISUAL REFERENCE
			this.userVoiceToText = this.testObjectVUI;

			let source1RegEx = XRegExp.build('(?x) {{source1Name}} | {{label1Name}}', {
							source1Name: XRegExp.build('{{source1Name1}} | {{source1Name2}}', {
							   	source1Name1: /source\sone/,
							    source1Name2: /source\s1/
							}),
							label1Name: XRegExp.build('{{label1Name1}} | {{label1Name2}}', {
							   	label1Name1: /streets?/,
							    label1Name2: /sidewalk/
							}),
				    	}, 'xgi');

			let source2RegEx = XRegExp.build('(?x) {{source2Name}} | {{label2Name}}', {
							source2Name: XRegExp.build('{{source2Name1}} | {{source2Name2}}', {
							   source2Name1: /source\stw?o?o/,
							   source2Name2: /source\s2/
							}),
							label2Name: XRegExp.build('{{label2Name1}} | {{label2Name2}}', {
							   	label2Name1: /humans?|walla/,
							    label2Name2: /people|persons?/
							}),
				    	}, 'xgi');

			let source3RegEx = XRegExp.build('(?x) {{source3Name}} | {{label3Name}}', {
							source3Name: XRegExp.build('{{source3Name1}} | {{source3Name2}}', {
							    source3Name1: /source\sthree/,
							    source3Name2: /source\s3/
							}),
							label3Name: XRegExp.build('{{label3Name1}} | {{label3Name2}}', {
							   	label3Name1: /subway\sstations?/,
							    label3Name2: /station/
							}),
				    	}, 'xgi');

			let source4RegEx = XRegExp.build('(?x) {{source4Name}} | {{label4Name}}', {
							source4Name: XRegExp.build('{{source4Name1}} | {{source4Name2}}', {
							    source4Name1: /source\sfou?re?/,
							    source4Name2: /source\s4/
							}),
							label4Name: XRegExp.build('{{label4Name1}} | {{label4Name2}}', {
							   	label4Name1: /subway\scars?/,
							    label4Name2: /train\scars?|train/
							}),
				    	}, 'xgi');

			let source5RegEx = XRegExp.build('(?x) {{source5Name}} | {{label5Name}}', {
							source5Name: XRegExp.build('{{source5Name1}} | {{source5Name2}}', {
							    source5Name1: /source\sfive/,
							    source5Name2: /source\s5/
							}),
							label5Name: XRegExp.build('{{label5Name1}} | {{label5Name2}}', {
							   	label5Name1: /8th|floor|8|eight|ate/,
							    label5Name2: /building/
							}),
				    	}, 'xgi');

			let source6RegEx = XRegExp.build('(?x) {{source6Name}} | {{label6Name}}', {
							source6Name: XRegExp.build('{{source6Name1}} | {{source6Name2}}', {
							    source6Name1: /source\ss[ei]x/,
							    source6Name2: /source\s6/
							}),
							label6Name: XRegExp.build('{{label6Name1}} | {{label6Name2}}', {
							   	label6Name1: /skyscraper|penthouse/,
							    label6Name2: /top\sfloor/
							}),
				    	}, 'xgi');
			//ALL SOUNDS
			let allSoundRegEx = XRegExp.build('(?x) {{allSoundName}}', {
							allSoundName: XRegExp.build('{{allSoundName1}} | {{allSoundName2}}', {
							    allSoundName1: /all\ssounds?/,
							    allSoundName2: /all\saudios?/
							}),
				    	}, 'xgi');
			//SPEED
			let speedRegEx = XRegExp.build('(?x) {{speedName}}', {
							speedName: XRegExp.build('{{speedName1}} | {{speedName2}}', {
							    speedName1: /speeds?/,
							    speedName2: /slow|faster/
							}),
				    	}, 'xgi');
			//DELAY
			let delayRegEx = XRegExp.build('(?x) {{delayName}}', {
							delayName: XRegExp.build('{{delayName1}} | {{delayName2}}', {
							    delayName1: /delay/,
							    delayName2: /lay/
							}),
				    	}, 'xgi');
			//CHORUS
			let chorusRegEx = XRegExp.build('(?x) {{chorusName}}', {
							chorusName: XRegExp.build('{{chorusName1}} | {{chorusName2}}', {
							    chorusName1: /chorus?/,
							    chorusName2: /course/
							}),
				    	}, 'xgi');
			//FILTER
			let filterRegEx = XRegExp.build('(?x) {{filterName}}', {
							filterName: XRegExp.build('{{filterName1}} | {{filterName2}}', {
							    filterName1: /filter/,
							    filterName2: /filter/
							}),
				    	}, 'xgi');
			//REVERB
			let reverbRegEx = XRegExp.build('(?x) {{reverbName}}', {
							reverbName: XRegExp.build('{{reverbName1}} | {{reverbName2}}', {
							    reverbName1: /verb/,
							    reverbName2: /reverb/
							}),
				    	}, 'xgi');
			//SHOW
			let infoRegEx = XRegExp.build('(?x) {{showName}}', {
							showName: XRegExp.build('{{showName1}} | {{showName2}}', {
							    showName1: /info/,
							    showName2: /information/
							}),
				    	}, 'xgi');
			// console.log(infoRegEx);
			//HIDE
			let listRegEx = XRegExp.build('(?x) {{hideName}}', {
							hideName: XRegExp.build('{{hideName1}} | {{hideName2}}', {
							    hideName1: /lists?/,
							    hideName2: /menu/
							}),
				    	}, 'xgi');
			// console.log(listRegEx);			

			let source1Boolean = source1RegEx.test(this.testObjectVUI);
			let source2Boolean = source2RegEx.test(this.testObjectVUI);
			let source3Boolean = source3RegEx.test(this.testObjectVUI);
			let source4Boolean = source4RegEx.test(this.testObjectVUI);
			let source5Boolean = source5RegEx.test(this.testObjectVUI);
			let source6Boolean = source6RegEx.test(this.testObjectVUI);
			let allSoundBoolean = allSoundRegEx.test(this.testObjectVUI);
			let speedBoolean 	= speedRegEx.test(this.testObjectVUI);
			let delayBoolean 	= delayRegEx.test(this.testObjectVUI);
			let chorusBoolean   = chorusRegEx.test(this.testObjectVUI);
			let filterBoolean   = filterRegEx.test(this.testObjectVUI);
			let reverbBoolean   = reverbRegEx.test(this.testObjectVUI);
			let infoBoolean   	= infoRegEx.test(this.testObjectVUI);
			let listBoolean   	= listRegEx.test(this.testObjectVUI);
			
			if (source1Boolean){this.source1VUI();}
			else if (source2Boolean){this.source2VUI();}
			else if (source3Boolean){this.source3VUI();}
			else if (source4Boolean){this.source4VUI();}
			else if (source5Boolean){this.source5VUI();}
			else if (source6Boolean){this.source6VUI();}
			else if (allSoundBoolean){this.allSoundVUI();}
			else if (speedBoolean){this.speedVUI();}
			else if (delayBoolean){this.delayVUI();}
			else if (chorusBoolean){this.chorusVUI();}
			else if (filterBoolean){this.filterVUI();}
			else if (reverbBoolean){this.reverbVUI();}
			else if (infoBoolean){this.infoVUI();}
			else if (listBoolean){this.listVUI();}
			else {
				this.miscVUI();
			}
		},
		source1VUI(){
				if    ((RegExp(/un\s?mute|play/gi).test(this.testObjectVUI))
					|| (RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI))
					|| (RegExp(/\bon\b/gi).test(this.testObjectVUI))){
						
						this.ambience1Player.start();
						this.ambience1Boolean = true;
				} else if ((RegExp(/stop/gi).test(this.testObjectVUI))
						|| (RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bmute\b/gi).test(this.testObjectVUI))){
						
						this.ambience1Player.stop();
						this.ambience1Boolean = false;

				} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience1Vol < 0){this.ambience1Vol +=12;}
						} else {
							if (this.ambience1Vol < 0){this.ambience1Vol +=6;}
						}

				} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience1Vol > -30){this.ambience1Vol -=12;}
						} else {	
							if (this.ambience1Vol > -30){this.ambience1Vol -=6;}
						}
				}
				this.testObjectVUI = "";	
		},
		source2VUI(){
				if    ((RegExp(/un\s?mute|play/gi).test(this.testObjectVUI))
					|| (RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI))
					|| (RegExp(/\bon\b/gi).test(this.testObjectVUI))){
						
						this.ambience2Player.start();
						this.ambience2Boolean = true;
				} else if ((RegExp(/stop/gi).test(this.testObjectVUI))
						|| (RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bmute\b/gi).test(this.testObjectVUI))){
						
						this.ambience2Player.stop();
						this.ambience2Boolean = false;

				} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience2Vol < 0){this.ambience2Vol +=12;}
						} else {
							if (this.ambience2Vol < 0){this.ambience2Vol +=6;}
						}

				} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience2Vol > -30){this.ambience2Vol -=12;}
						} else {	
							if (this.ambience2Vol > -30){this.ambience2Vol -=6;}
						}
				}
				this.testObjectVUI = "";	
		},
		source3VUI(){
				if    ((RegExp(/un\s?mute|play/gi).test(this.testObjectVUI))
					|| (RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI))
					|| (RegExp(/\bon\b/gi).test(this.testObjectVUI))){
						
						this.ambience3Player.start();
						this.ambience3Boolean = true;
				} else if ((RegExp(/stop/gi).test(this.testObjectVUI))
						|| (RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bmute\b/gi).test(this.testObjectVUI))){
						
						this.ambience3Player.stop();
						this.ambience3Boolean = false;

				} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience3Vol < 0){this.ambience3Vol +=12;}
						} else {
							if (this.ambience3Vol < 0){this.ambience3Vol +=6;}
						}

				} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience3Vol > -30){this.ambience3Vol -=12;}
						} else {	
							if (this.ambience3Vol > -30){this.ambience3Vol -=6;}
						}
				}
				this.testObjectVUI = "";	
		},
		source4VUI(){
				if    ((RegExp(/un\s?mute|play/gi).test(this.testObjectVUI))
					|| (RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI))
					|| (RegExp(/\bon\b/gi).test(this.testObjectVUI))){
						
						this.ambience4Player.start();
						this.ambience4Boolean = true;
				} else if ((RegExp(/stop/gi).test(this.testObjectVUI))
						|| (RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bmute\b/gi).test(this.testObjectVUI))){
						
						this.ambience4Player.stop();
						this.ambience4Boolean = false;

				} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience4Vol < 0){this.ambience4Vol +=12;}
						} else {
							if (this.ambience4Vol < 0){this.ambience4Vol +=6;}
						}

				} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience4Vol > -30){this.ambience4Vol -=12;}
						} else {	
							if (this.ambience4Vol > -30){this.ambience4Vol -=6;}
						}
				}
				this.testObjectVUI = "";	
		},
		source5VUI(){
				if    ((RegExp(/un\s?mute|play/gi).test(this.testObjectVUI))
					|| (RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI))
					|| (RegExp(/\bon\b/gi).test(this.testObjectVUI))){
						
						this.ambience5Player.start();
						this.ambience5Boolean = true;
				} else if ((RegExp(/stop/gi).test(this.testObjectVUI))
						|| (RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bmute\b/gi).test(this.testObjectVUI))){
						
						this.ambience5Player.stop();
						this.ambience5Boolean = false;

				} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience5Vol < 0){this.ambience5Vol +=12;}
						} else {
							if (this.ambience5Vol < 0){this.ambience5Vol +=6;}
						}

				} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience5Vol > -30){this.ambience5Vol -=12;}
						} else {	
							if (this.ambience5Vol > -30){this.ambience5Vol -=6;}
						}
				}
				this.testObjectVUI = "";	
		},
		source6VUI(){
				if    ((RegExp(/un\s?mute|play/gi).test(this.testObjectVUI))
					|| (RegExp(/\baddi?n?g?\b/gi).test(this.testObjectVUI))
					|| (RegExp(/\bon\b/gi).test(this.testObjectVUI))){
						
						this.ambience6Player.start();
						this.ambience6Boolean = true;
				} else if ((RegExp(/stop/gi).test(this.testObjectVUI))
						|| (RegExp(/\btake\s?out\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bt?u?r?n?\b\s?\boff\b/gi).test(this.testObjectVUI))
						|| (RegExp(/\bmute\b/gi).test(this.testObjectVUI))){
						
						this.ambience6Player.stop();
						this.ambience6Boolean = false;

				} else if (RegExp(/\bup\b|loude?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience6Vol < 0){this.ambience6Vol +=12;}
						} else {
							if (this.ambience6Vol < 0){this.ambience6Vol +=6;}
						}

				} else if (RegExp(/\bdown\b|softe?r?/gi).test(this.testObjectVUI)){
						
						if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
							if (this.ambience6Vol > -30){this.ambience6Vol -=12;}
						} else {	
							if (this.ambience6Vol > -30){this.ambience6Vol -=6;}
						}
				}
				this.testObjectVUI = "";	
		},
		allSoundVUI(){
			//STOP ALL 
				if ((RegExp(/stop/gi).test(this.testObjectVUI))){
						this.ambience1Player.stop();
						this.ambience1Boolean = false;
						this.ambience2Player.stop();
						this.ambience2Boolean = false;
						this.ambience3Player.stop();
						this.ambience3Boolean = false;
						this.ambience4Player.stop();
						this.ambience4Boolean = false;
						this.ambience5Player.stop();
						this.ambience5Boolean = false;
						this.ambience6Player.stop();
						this.ambience6Boolean = false;
						if(this.didWeAdventure){
							this.exploreSound1.stop();
							this.isExploreFuncRunning = false;
							this.stopExplore();
						}
				} else if ((RegExp(/play/gi).test(this.testObjectVUI))){
						this.ambience1Player.start();
						this.ambience1Boolean = true;
						this.ambience2Player.start();
						this.ambience2Boolean = true;
						this.ambience3Player.start();
						this.ambience3Boolean = true;
						this.ambience4Player.start();
						this.ambience4Boolean = true;
						this.ambience5Player.start();
						this.ambience5Boolean = true;
						this.ambience6Player.start();
						this.ambience6Boolean = true;
				}
				this.testObjectVUI = "";	
		},
		speedVUI(){
				if ((RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI))){
					this.speedToggle = true;
				} else if ((RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI))){
					this.speedToggle = false;
				}
				if ((RegExp(/\bfaste?r?\b|up/gi).test(this.testObjectVUI))){
					if (RegExp(/\bmuch\b/gi).test(this.testObjectVUI)){
						if (this.playBackSpeed <= 1.6){this.playBackSpeed += 0.4;}
					} else {	
						if (this.playBackSpeed <= 1.8){this.playBackSpeed += 0.2;}
					}
				} else if ((RegExp(/slowe?r?|down/gi).test(this.testObjectVUI))){
					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.playBackSpeed >= 0.5){this.playBackSpeed -= 0.4;}
					} else {	
						if (this.playBackSpeed >= 0.2){this.playBackSpeed -= 0.2;}
					}
				} 
				this.testObjectVUI = "";	
		},
		delayVUI(){
				if ((RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI))){
					this.fxDelayToggle = true;
				} else if ((RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI))){
					this.fxDelayToggle = false;
				}
				if ((RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI))){
					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.fxDelayAmt <= 80){this.fxDelayAmt += 10;}
					} else {	
						if (this.fxDelayAmt <= 95){this.fxDelayAmt += 5;}
					}
				} else if ((RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI))){
					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.fxDelayAmt >=20){this.fxDelayAmt -= 10;} 
						else if (this.fxDelayAmt >=5){this.fxDelayAmt -= 5;} 
					} else {	
						if (this.fxDelayAmt >=5){this.fxDelayAmt -= 5;}
						else if (this.fxDelayAmt >=15){this.fxDelayAmt -= 2;}
					}
				}
				this.testObjectVUI = "";	
		},
		chorusVUI(){
				if ((RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI))){
					this.fxChorusToggle = true;
				} else if ((RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI))){
					this.fxChorusToggle = false;
				}
				if ((RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI))){
					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.fxChorusAmt <= 80){this.fxChorusAmt += 10;}
					} else {	
						if (this.fxChorusAmt <= 95){this.fxChorusAmt += 5;}
					}
				} else if ((RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI))){
					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.fxChorusAmt >=20){this.fxChorusAmt -= 10;} 
						else if (this.fxChorusAmt >=5){this.fxChorusAmt -= 5;} 
					} else {	
						if (this.fxChorusAmt >=5){this.fxChorusAmt -= 5;}
						else if (this.fxChorusAmt >=15){this.fxChorusAmt -= 2;}
					}
				}
				this.testObjectVUI = "";	
		},
		reverbVUI(){
				if ((RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI))){
					this.fxConvolverToggle = true;
				} else if ((RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI))){
					this.fxConvolverToggle = false;
				}
				if ((RegExp(/\bmore\b|\bup\b|loude?r?/gi).test(this.testObjectVUI))){
					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.fxConvolverAmt <= 45){this.fxConvolverAmt += 5;}
					} else {	
						if (this.fxConvolverAmt <= 48){this.fxConvolverAmt += 2;}
					}
				} else if ((RegExp(/less|\bdown\b|softe?r?/gi).test(this.testObjectVUI))){
					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.fxConvolverAmt >=10){this.fxConvolverAmt -= 5;} 
						else if (this.fxConvolverAmt >=2){this.fxConvolverAmt -= 1;} 
					} else {	
						if (this.fxConvolverAmt >=10){this.fxConvolverAmt -= 2;}
						else if (this.fxConvolverAmt >=2){this.fxConvolverAmt -= 1;}
					}
				}
				this.testObjectVUI = "";	
		},
		filterVUI(){
				if ((RegExp(/\bon\b|\bengage\b/gi).test(this.testObjectVUI))){
					this.fxFilterToggle = true;
				} else if ((RegExp(/\boff\b|\bdisengage\b/gi).test(this.testObjectVUI))){
					this.fxFilterToggle = false;
				}
				if ((RegExp(/\bmore\b|\blower\b/gi).test(this.testObjectVUI))){

					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.fxAutoFilterAmt > 1500){this.fxAutoFilterAmt -= 1500;}
						else if (this.fxAutoFilterAmt >= 300){this.fxAutoFilterAmt -= 200;}
					} else {	
						if (this.fxAutoFilterAmt >= 500){this.fxAutoFilterAmt -= 250;}
						else if (this.fxAutoFilterAmt >= 100){this.fxAutoFilterAmt -= 100;}
					}
				} else if ((RegExp(/less|higher|hire/gi).test(this.testObjectVUI))){
					
					if (RegExp(/\bmuch\b|a\s?lot/gi).test(this.testObjectVUI)){
						if (this.fxAutoFilterAmt <= 10000){this.fxAutoFilterAmt += 1500;} 
						else if (this.fxAutoFilterAmt <= 1000){this.fxAutoFilterAmt += 200;} 
					} else {	
						if (this.fxAutoFilterAmt <= 10000){this.fxAutoFilterAmt += 250;} 
						else if (this.fxAutoFilterAmt <= 1000){this.fxAutoFilterAmt += 100;} 
					}  
				}
				this.testObjectVUI = "";	
		},
		infoVUI(){
				if (RegExp(/show|display/gi).test(this.testObjectVUI)){
					this.showHelpOverlay = true;
						setTimeout(()=>{
							this.showNavBar = false;
							if (this.$store.state.allowSpeechControl){this.showSpeechBtns = false;}
						}, 0);
						setTimeout(()=>{
							this.showAllControls = false;
						}, 500);
						setTimeout(()=>{
							this.showAboutPage = true;
						}, 1500);
						console.log('SHOW INFO');
				} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)){
						this.showHelpOverlay = false;
						this.showAboutPage = false;	
						setTimeout(()=>{
							this.showAllControls = true;
						}, 800);	
						setTimeout(()=>{
							this.showNavBar = true;
							if (this.$store.state.allowSpeechControl){this.showSpeechBtns = true;}
						}, 850);
						console.log('HIDE INFO');
				}  
				this.testObjectVUI = "";
				setTimeout(()=> {this.userVoiceToText = "";}, 3000);
		},
		listVUI(){
				if (RegExp(/show|display/gi).test(this.testObjectVUI)){
					this.showVoiceCommandList = true;
					setTimeout(()=>{
						document.getElementById('voiceControlListTxt').scrollIntoView({behavior: "smooth"});
					}, 250);
					console.log('SHOW LIST');
				} else if (RegExp(/hide|minimize/gi).test(this.testObjectVUI)){
					this.showVoiceCommandList = false;
					setTimeout(()=>{
						document.getElementById('controlsContainer').scrollIntoView({behavior: "smooth"});
					}, 250);
					console.log('HIDE LIST');
				}
				this.testObjectVUI = "";
				setTimeout(()=> {this.userVoiceToText = "";}, 3000);
		},
		miscVUI(){
			//RANDOMIZE
				if ((RegExp(/new\s?scenes?|randomi?z?e?|shift\s?soundscapes?/gi).test(this.testObjectVUI))){
					this.mattChillMethod();
			//EXPLORE
				} else if ((RegExp(/\bexplorer?\b|\badventure\b/gi).test(this.testObjectVUI))){
					if ((RegExp(/stop/gi).test(this.testObjectVUI))){
							this.stopExplore();
						} else {
							this.exploreFunc();
						}
			//STOP VOICE COMMANDS & GO HOME FUNCTIONS
				} else if ((RegExp(/stop/gi).test(this.testObjectVUI)) 
						&& (RegExp(/voice\s?controls?/gi).test(this.testObjectVUI))
						|| (RegExp(/stop/gi).test(this.testObjectVUI))
						&& (RegExp(/voice\s?commands?/gi).test(this.testObjectVUI))) {
					//DISABLES LISTENING IMMEDITATLY
					this.initSpeech = true;
					this.stopModuleSpeech = true;
					this.recognizing = false;
					this.recognitionNYC.stop();
					this.$store.state.isVoiceControlled = false;

				} else if (RegExp(/home/gi).test(this.testObjectVUI)){
					this.goingHomeNotViaVoiceCommand = false;
					this.stopModuleSpeech = true;
					this.recognitionNYC.abort();
					this.recognitionNYC = undefined;
					setTimeout(this.goHome, 50);
				}
			this.testObjectVUI = "";	
		},
		voiceCommandListFunc(){
			this.showVoiceCommandList = !this.showVoiceCommandList;
			if (this.showVoiceCommandList){	
				setTimeout(()=>{
					document.getElementById('voiceControlListTxt').scrollIntoView({behavior: "smooth"});
				}, 250);
			} else if (!this.showVoiceCommandList){
					document.getElementById('controlsContainer').scrollIntoView({behavior: "smooth"});
			}
		},
	//ENTER FUNC
		enterFunc(){
			if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
				 

						this.showMutePrompt = false;
						this.showEnterBtn = false;

						setTimeout(()=>{
							this.showEnterContainer = false;
						}, 1000);

				this.metroFX.start();

				let changeTiming = 50;
			
						setTimeout(()=>{ 
						this.plungeDepth = 1;
						}, changeTiming * 1);

						setTimeout(()=>{ 
						this.plungeDepth = 2;
						}, changeTiming * 2);

						setTimeout(()=>{ 
						this.plungeDepth = 3;
						}, changeTiming * 3);

						setTimeout(()=>{ 
						this.plungeDepth = 4;
						}, changeTiming * 4);

						setTimeout(()=>{ 
						this.plungeDepth = 5;
						}, changeTiming * 5);

						setTimeout(()=>{ 
						this.plungeDepth = 6;
						}, changeTiming * 6);

						setTimeout(()=>{ 
						this.plungeDepth = 7;
						}, changeTiming * 7);

						setTimeout(()=>{ 
						this.plungeDepth = 8;
						}, changeTiming * 8);

						setTimeout(()=>{ 
						this.plungeDepth = 9;
						}, changeTiming * 8);

						setTimeout(()=>{ 
						this.plungeDepth = 10;
						}, changeTiming * 10);


						setTimeout(()=>{ 
						this.showAllControls = true;
						}, 1000);

						setTimeout(()=>{ 
						this.showNavBar = true;
						}, 1200);

						setTimeout(()=>{ 
						this.showMicRecording = true;
						}, 1000);
					
						setTimeout(()=>{ 
						this.showSpeechBtns = true;
						}, 1100);
					
						setTimeout(()=>{ 
							this.ambience4Boolean = true;
						}, 2523);

						setTimeout(()=>{ 
							if(this.userMobile === false){
								this.activeSun = true;
							}
						}, 2000);
				},
	//RANDOMIZE (MATT CHILL) PRESET
		mattChillMethod(){
			if (this.didWeAdventure){
				this.stopExplore();
			}
			
			if (this.randomizeBoolean === false){
				this.randomizeBoolean = true;
			}

			this.mattChill = !this.mattChill;

			let ambience1Volume = Math.floor((Math.random() * 30) - 30),
				ambience2Volume = Math.floor((Math.random() * 30) - 30),
				ambience3Volume = Math.floor((Math.random() * 30) - 30),
				ambience4Volume = Math.floor((Math.random() * 30) - 30),
				ambience5Volume = Math.floor((Math.random() * 30) - 30),
				ambience6Volume = Math.floor((Math.random() * 5) - 5);

			// let fx1boolean 		= Math.random() >= 0.5,
			// 	fx2boolean 		= Math.random() >= 0.5,
			// 	fx3boolean 		= Math.random() >= 0.5,
			// 	fx4boolean 		= Math.random() >= 0.5,
			// 	fx5boolean 		= Math.random() >= 0.5;

			let amb1boolean 	= Math.random() >= 0.5,
				amb2boolean 	= Math.random() >= 0.5,
				amb3boolean 	= Math.random() >= 0.5,
				amb4boolean 	= Math.random() >= 0.5,
				amb5boolean 	= Math.random() >= 0.5,
				amb6boolean 	= Math.random() >= 0.5;

			this.subwayFilter.frequency.value = 20000;

			// if (this.mattChill === true){
				//DON'T CALCULATE ON MOBILE
				if (this.userMobile === false){
				let 
				// randomVerb 		= Math.floor((Math.random() * 30) + 0),
			 	randomDelay 	= Math.floor((Math.random() * 15) + 0),
			 	randomChorus 	= Math.floor((Math.random() * 10) + 0),
			 	randomFilter 	= Math.floor((Math.random() * 10000) + 500);

				// this.fxConvolverAmt 	= randomVerb;
				this.fxDelayAmt 		= randomDelay;
				this.fxChorusAmt 		= randomChorus;
				this.fxAutoFilterAmt 	= randomFilter;

				this.fxDecay = (Math.random() * 4) + 1;
				let fxPreDelay = (Math.random() * 0.1) + 0.03;
				this.fxConvolver.decay = this.fxDecay;
				this.fxConvolver.preDelay = fxPreDelay;
				this.fxConvolver.generate();	
				}
				//CALCULATE ON MOBILE & DESKTOP
				let randomSpeed 	= (Math.random() * (1.15 - 0.85) + 0.85);
				this.playBackSpeed 		= randomSpeed;

				this.ambience1Vol 		= ambience1Volume;
				this.ambience2Vol 		= ambience2Volume;
				this.ambience3Vol 		= ambience3Volume;
				this.ambience4Vol 		= ambience4Volume;
				this.ambience5Vol 		= ambience5Volume;
				this.ambience6Vol 		= ambience6Volume;

				if (amb1boolean === true){
					this.ambience1Boolean = true;
					this.showFlask1 = true;

					this.subwayFilter.frequency.value = 1500;
				} else {
					this.ambience1Boolean = false;
					this.showFlask1 = false;
				}

				if (amb2boolean === true){
					this.ambience2Boolean = true;
					this.showFlask2 = true;
				} else {
					this.ambience2Boolean = false;
					this.showFlask2 = false;
				}

				if (amb3boolean === true){
					this.ambience3Boolean = true;
					this.showFlask3 = true;
				} else {
					this.ambience3Boolean = false;
					this.showFlask3 = false;
				}

				if (amb4boolean === true){
					this.ambience4Boolean = true;
					this.showFlask4 = true;

					this.subwayFilter.frequency.value = 1500;
				} else {
					this.ambience4Boolean = false;
					this.showFlask4 = false;
				}

				if (amb5boolean === true){
					this.ambience5Boolean = true;
					this.showFlask5 = true;

					this.ambience2Boolean = false;
					this.showFlask2 = false;

					this.ambience3Boolean = false;
					this.showFlask3 = false;

					this.ambience4Boolean = false;
					this.showFlask4 = false;

					this.streetFilter.frequency.value = 1000;
				} else {
					this.ambience5Boolean = false;
					this.showFlask5 = false;
				}

				if (amb6boolean === true){
					this.ambience6Boolean = true;
					this.showFlask6 = true;

					this.ambience2Boolean = false;
					this.showFlask2 = false;

					this.ambience3Boolean = false;
					this.showFlask3 = false;

					this.ambience4Boolean = false;
					this.showFlask4 = false;

					this.streetFilter.frequency.value = 250;
				} else {
					this.ambience6Boolean = false;
					this.showFlask6 = false;
				}

				if ((amb1boolean === false) &&
					(amb2boolean === false) &&
					(amb3boolean === false) &&
					(amb4boolean === false) &&
					(amb5boolean === false) &&
					(amb6boolean === false))
				 	{
					this.ambience6Boolean = true;
					this.showFlask6 = true;	
				}
				
			// } else if (this.mattChill === false){
				// this.fxDelayToggle = false;
				// this.fxConvolverToggle = false;
				// this.fxChorusToggle = false;
				// this.fxFilterToggle = false;
				// this.speedToggle = false;
			// } 
		},
	//EXPLORE 
		exploreBtnFunc(){
			this.exploreBtnBoolean = !this.exploreBtnBoolean;
			if (this.exploreBtnBoolean){
				this.exploreFunc();
			} else if (!this.exploreBtnBoolean){
				this.stopExplore();
			}
		},
		exploreFunc(){
			//AUDIO MIXING FUNCTION
				let int = 250;
				let runExplore = ()=>{
					this.exploreSound1.start();
					this.speedToggle = false;
					this.exploreTxt = "Exploring";
					this.exploreTimeout1 = setTimeout(()=>{

						this.exploreTimeout2 = setTimeout(()=>{
							this.ambience4Boolean = true;
							this.ambience4Vol = -10;
						}, int * 1);

						this.exploreTimeout3 = setTimeout(()=>{
							this.ambience4Vol = -4;
						}, int * 2);

						this.exploreTimeout4 = setTimeout(()=>{
							this.ambience4Vol = -2;
						}, int * 3);

						this.exploreTimeout5 = setTimeout(()=>{
							this.ambience4Vol = 0;
						}, int * 4);

						this.exploreTimeout6 = setTimeout(()=>{
							this.ambience4Vol = 2;
						}, int * 5);

						this.exploreTimeout7 = setTimeout(()=>{
							this.ambience4Vol = 3;
						}, int * 6);

						this.exploreTimeout8 = setTimeout(()=>{
							this.ambience4Vol = 4;
						}, int * 7);

						this.exploreTimeout9 = setTimeout(()=>{
							this.ambience4Vol = 5;
						}, int * 8);

						this.exploreTimeout10 = setTimeout(()=>{
							this.ambience4Vol = 6;
						}, int * 9);

						this.exploreTimeout11 = setTimeout(()=>{
							this.ambience4Vol = 7;
							// this.exploreSound1.volume.setTargetAtTime(-8, Tone.context.currentTime, +1.5);
						}, int * 10);

						this.exploreTimeout12 = setTimeout(()=>{
							this.ambience4Vol = 8;
							// this.ambience3Player.start();
							// this.ambience3Boolean = true;
							// this.ambience3Vol = -6;
						}, int * 11);	

						this.exploreTimeout13 = setTimeout(()=>{
							this.ambience4Vol = 10;
							// this.ambience3Vol = -4;
							this.isExploreFuncRunning = false;
							this.exploreTxt = "Explore!";
						}, int * 12);
					}, 121100);
				};
			if (this.isExploreFuncRunning === false){
				this.isExploreFuncRunning = true;
				//INIT EXPORE SCENE
					//GENERATE REVERB
					// this.fxDecay = 4.5;
					// this.fxConvolver.decay = this.fxDecay;
					// this.fxConvolver.preDelay = 0.4;
					// this.fxConvolver.generate();
					
						this.ambience1Boolean = false;
						this.ambience2Boolean = false;
						this.ambience3Boolean = false;
						this.ambience4Boolean = false;
						this.ambience5Boolean = false;
						this.ambience6Boolean = false;
						
				
			if(!this.didWeAdventure){		
				this.exploreSound1 = new Tone.Player({
				  							"playbackRate" : 1,
				  							"loop" : false,
				  							"volume": -7,
				  							}).connect(this.masterVolumeSub);
				
				//LOADING FOR BROWSER TYPE
				if (this.isChrome === true || 
					this.isOpera === true || 
					this.isFirefox === true || 
					this.isBlink === true){
							
					this.exploreSound1.load("../src/assets/sounds/modules/metro/hiogg/exporeSound1metro.ogg",
									()=>{
										runExplore();
									});		
				} else if (
					this.AndroidMobile === true){
					this.exploreSound1.load("../src/assets/sounds/modules/metro/lowogg/exporeSound1metro.ogg",
									()=>{
										runExplore();
									});		
				} else if (
					this.isSafari === true ||
					this.isEdge === true || 
					this.isIE === true){
					this.exploreSound1.load("../src/assets/sounds/modules/metro/320/exporeSound1metro.m4a",
									()=>{
										runExplore();
									});		
				} else if (
					this.iOS === true ){
					this.exploreSound1.load("../src/assets/sounds/modules/metro/192/exporeSound1metro.m4a",
									()=>{
										runExplore();
									});		
				}
					//CLEANS UP AND DISPOSES THESE PLAYERS WHEN GOING HOME
					this.didWeAdventure = true;
				} else if (this.didWeAdventure){
					runExplore();
					this.exploreTxt = "Exploring!";
				}
			} else {
			}
		},
		stopExplore(){
				this.exploreTxt = "Explore!";
				this.exploreSound1.stop();
				this.isExploreFuncRunning = false;
				clearInterval(this.exploreTimeout1);
				clearInterval(this.exploreTimeout2);
				clearInterval(this.exploreTimeout3);
				clearInterval(this.exploreTimeout4);
				clearInterval(this.exploreTimeout5);
				clearInterval(this.exploreTimeout6);
				clearInterval(this.exploreTimeout7);
				clearInterval(this.exploreTimeout8);
				clearInterval(this.exploreTimeout9);
				clearInterval(this.exploreTimeout10);
				clearInterval(this.exploreTimeout11);
				clearInterval(this.exploreTimeout12);
				clearInterval(this.exploreTimeout13);
		},
	//MASTER METERING
		masterMetering(){
			this.masterLevel = this.masterMeter.getLevel();
		},
	//MAIN SHOW AND HIDE
		goToHelp(){
					this.showHelpOverlay = !this.showHelpOverlay;
					this.helpTrigger = !this.helpTrigger

					if (this.showHelpOverlay === true){

						setTimeout(()=>{
							this.showNavBar = false;
							if (this.$store.state.allowSpeechControl){this.showSpeechBtns = false;}
						}, 100);

						setTimeout(()=>{
							this.showAllControls = false;
						}, 250);

						setTimeout(()=>{
							this.showAboutPage = true;
						}, 1000);

					} else if (this.showHelpOverlay === false){	

						this.showAboutPage = false;	

						setTimeout(()=>{
							this.showAllControls = true;
						}, 800);	

						setTimeout(()=>{
							this.showNavBar = true;
							if (this.$store.state.allowSpeechControl){this.showSpeechBtns = true;}
						}, 850);		
					}
			},
	//BUFFER LOADING
		bufferLoading(){
				
				// Tone.Buffer.on('progress', ()=>{
				// });
				Tone.Buffer.on('load', ()=>{					
					//HIDE LOADING ITEMS
					this.showLoading = false;
					//SHOW ENTER BUTTON
					setTimeout(()=>{
						this.showEnterBtn = true;
					}, 1000);
					//AUTO OPEN MODULE IF VOICE CONTROLLED & DO NOT REPLAY WHEN EXPLORE AUDIO LOADS 
					//ADDITIONALLY DO NOT REPLAY IF USER MIC HAS BEEN ACTIVATED FOR RECORDING
					if (this.isVoiceControl){
						if (!this.didWeAdventure){
							setTimeout(this.enterFunc, 2000);
						}
					}
					//IF VOICE CONTROL IS ACTIVE GLOBALLY ACTIVATE IN THIS MODULE
					if (this.isVoiceControl === true){
						this.speechFunc();
					}
				})
		},
	//AUDIO ROUTING
		audioRouting(){
				if (
					this.isChrome === true || 
					this.AndroidMobile === true || 
					this.isOpera === true || 
					this.isFirefox === true || 
					this.isBlink === true){
					if (this.userMobile === false){ 

						this.fxConvolver = new Tone.Reverb({
												"decay"  : 1.5 ,
												"preDelay"  : 0.01
												});
						this.fxConvolver.decay = 2.5;
						this.fxConvolver.generate();
						this.fxAutoFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
						this.fxDelay = new Tone.PingPongDelay(0.45, 0.45);
						this.fxChorus = new Tone.Chorus(1.25, 5.5, 1.25);
						this.masterMeter = new Tone.Meter({
													"smoothing"  : .4
													});
						this.subwayFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
						this.streetFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
						this.ambience1Player.chain(this.streetFilter, this.masterVolumeSub);
						this.ambience2Player.connect(this.masterVolumeSub);
						this.ambience3Player.chain(this.subwayFilter, this.masterVolumeSub);
						this.ambience4Player.connect(this.masterVolumeSub);
						this.ambience5Player.connect(this.masterVolumeSub);
						this.ambience6Player.connect(this.masterVolumeSub);

						this.masterVolumeSub.chain(
									  this.fxAutoFilter,
									  this.fxConvolver, 
									  this.fxDelay, 
								  	  this.fxChorus,
								  	  this.masterMeter,
								  	  Tone.Master);
						console.log('Chrome/Opera/FireFox Desktop');
						setInterval(this.masterMetering, 60);
					
					} else if (this.userMobile === true){
						this.subwayFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
						this.streetFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
						this.ambience1Player.chain(this.streetFilter, this.masterVolumeSub);
						this.ambience2Player.connect(this.masterVolumeSub);
						this.ambience3Player.connect(this.masterVolumeSub);
						this.ambience3Player.chain(this.subwayFilter, this.masterVolumeSub);
						this.ambience5Player.connect(this.masterVolumeSub);
						this.ambience6Player.connect(this.masterVolumeSub);

						this.masterVolumeSub.connect(Tone.Master);

						console.log('Chrome/Opera/FireFox Mobile');
					}
				} else if (
					this.isSafari === true || 
					this.iOS === true || 
					this.isEdge === true || 
					this.isIE === true){
					if (this.userMobile === false){ 
							this.fxConvolver = new Tone.Reverb({
												"decay"  : 1.5 ,
												"preDelay"  : 0.01
												});
							this.fxConvolver.decay = 2.5;
							this.fxConvolver.generate();
							this.fxAutoFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
							this.fxDelay = new Tone.PingPongDelay(0.45, 0.45);
							this.fxChorus = new Tone.Chorus(1.25, 5.5, 1.25);
							this.masterMeter = new Tone.Meter({
													"smoothing"  : .4
													});
							this.subwayFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
							this.streetFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
							this.ambience1Player.chain(this.streetFilter, this.masterVolumeSub);
							this.ambience2Player.connect(this.masterVolumeSub);
							this.ambience3Player.chain(this.subwayFilter, this.masterVolumeSub);
							this.ambience4Player.connect(this.masterVolumeSub);
							this.ambience5Player.connect(this.masterVolumeSub);
							this.ambience6Player.connect(this.masterVolumeSub);

							this.masterVolumeSub.chain(
													  this.fxAutoFilter,
													  this.fxConvolver, 
													  this.fxDelay, 
												  	  this.fxChorus, 
												  	  this.masterMeter,
												  	  Tone.Master);
						
							setInterval(this.masterMetering, 60);
							console.log('Safari/Edge/iOS Desktop');
					
					} else if (this.userMobile === true){
						this.subwayFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
						this.streetFilter = new Tone.Filter ({
												"type" : "lowpass",
												"frequency" : 20000,
												"rolloff" : -24,
												"Q" : 1,
												"gain" : 0
												});
						this.ambience1Player.chain(this.streetFilter, this.masterVolumeSub);
						this.ambience2Player.connect(this.masterVolumeSub);
						this.ambience3Player.chain(this.subwayFilter, this.masterVolumeSub);
						this.ambience4Player.connect(this.masterVolumeSub);
						this.ambience5Player.connect(this.masterVolumeSub);
						this.ambience6Player.connect(this.masterVolumeSub);

						this.masterVolumeSub.connect(Tone.Master);
						console.log('Safari/Edge/iOS Mobile');
					}
				} else {

				}
		},
	//AUDIO LOADING
				firstAudioLoadFunc(){
					
					// this.changeFX.load("../src/assets/sounds/blinks/change.wav", 
					// 	()=>{
					// 	this.whatIsLoading = "Steel";
					// });

					// this.metroFX.load("../src/assets/sounds/modules/metro/metroFX.wav", 
					// 	()=>{
					// 	this.whatIsLoading = "Concrete";
					// });

					// this.ambience1Player.load("../src/assets/sounds/modules/metro/street.wav", 
					// 	()=>{
					// 	this.whatIsLoading = "Streets";
					// });

					// this.ambience2Player.load("../src/assets/sounds/modules/metro/walla.wav", 
					// 	()=>{
					// 	this.whatIsLoading = "Humans";
					// });

					// this.ambience3Player.load("../src/assets/sounds/modules/metro/siren.wav", 
					// 	()=>{
					// 	this.whatIsLoading = "Siren";
					// });

					// this.ambience4Player.load("../src/assets/sounds/modules/metro/subway.wav",
					//  	()=>{
					// 	this.whatIsLoading = "Subway";
					// });

					// this.ambience5Player.load("../src/assets/sounds/modules/metro/subway.wav", 
					// 	()=>{
					// 	this.whatIsLoading = "Subway";
					// });

					// this.ambience6Player.load("../src/assets/sounds/modules/metro/subway.wav", 
					// 	()=>{
					// 	this.whatIsLoading = "Subway";
					// });

					if (this.isChrome === true || 
						this.isOpera === true || 
						this.isFirefox === true || 
						this.isBlink === true){
						
						this.changeFX.load("../src/assets/sounds/blinks/change.ogg", 
						()=>{
						this.whatIsLoading = "Steel";
						});

						this.metroFX.load("../src/assets/sounds/modules/metro/hiogg/metroFX.ogg", 
							()=>{
							this.whatIsLoading = "Concrete";
						});

						this.ambience1Player.load("../src/assets/sounds/modules/metro/hiogg/street.ogg", 
							()=>{
							this.whatIsLoading = "Avenues";
						});

						this.ambience2Player.load("../src/assets/sounds/modules/metro/hiogg/walla.ogg", 
							()=>{
							this.whatIsLoading = "Humans";
						});

						this.ambience3Player.load("../src/assets/sounds/modules/metro/hiogg/subwaystation.ogg", 
							()=>{
							this.whatIsLoading = "Subway";
						});

						this.ambience4Player.load("../src/assets/sounds/modules/metro/hiogg/subwaycar.ogg",
						 	()=>{
							this.whatIsLoading = "Subway Car";
						});

						this.ambience5Player.load("../src/assets/sounds/modules/metro/hiogg/skyscraper.ogg", 
							()=>{
							this.whatIsLoading = "Skyscraper";
						});

						this.ambience6Player.load("../src/assets/sounds/modules/metro/hiogg/penthouse.ogg", 
							()=>{
							this.whatIsLoading = "Penthouse";
						});
					} else if (this.AndroidMobile === true){
						this.changeFX.load("../src/assets/sounds/blinks/change.ogg", 
						()=>{
						this.whatIsLoading = "Steel";
						});

						this.metroFX.load("../src/assets/sounds/modules/metro/lowogg/metroFX.ogg", 
							()=>{
							this.whatIsLoading = "Concrete";
						});

						this.ambience1Player.load("../src/assets/sounds/modules/metro/lowogg/street.ogg", 
							()=>{
							this.whatIsLoading = "Avenues";
						});

						this.ambience2Player.load("../src/assets/sounds/modules/metro/lowogg/walla.ogg", 
							()=>{
							this.whatIsLoading = "Humans";
						});

						this.ambience3Player.load("../src/assets/sounds/modules/metro/lowogg/subwaystation.ogg", 
							()=>{
							this.whatIsLoading = "Subway";
						});

						this.ambience4Player.load("../src/assets/sounds/modules/metro/lowogg/subwaycar.ogg",
						 	()=>{
							this.whatIsLoading = "Subway Car";
						});

						this.ambience5Player.load("../src/assets/sounds/modules/metro/lowogg/skyscraper.ogg", 
							()=>{
							this.whatIsLoading = "Skyscraper";
						});

						this.ambience6Player.load("../src/assets/sounds/modules/metro/lowogg/penthouse.ogg", 
							()=>{
							this.whatIsLoading = "Penthouse";
						});
					} else if (
						this.isSafari === true || 
						this.isEdge === true || 
						this.isIE === true){
						
						this.changeFX.load("../src/assets/sounds/blinks/change.m4a", 
						()=>{
						this.whatIsLoading = "Steel";
						});

						this.metroFX.load("../src/assets/sounds/modules/metro/320/metroFX.m4a", 
							()=>{
							this.whatIsLoading = "Concrete";
						});

						this.ambience1Player.load("../src/assets/sounds/modules/metro/320/street.m4a", 
							()=>{
							this.whatIsLoading = "Avenues";
						});

						this.ambience2Player.load("../src/assets/sounds/modules/metro/320/walla.m4a", 
							()=>{
							this.whatIsLoading = "Humans";
						});

						this.ambience3Player.load("../src/assets/sounds/modules/metro/320/subwaystation.m4a", 
							()=>{
							this.whatIsLoading = "Subway";
						});

						this.ambience4Player.load("../src/assets/sounds/modules/metro/320/subwaycar.m4a",
						 	()=>{
							this.whatIsLoading = "Subway Car";
						});

						this.ambience5Player.load("../src/assets/sounds/modules/metro/320/skyscraper.m4a", 
							()=>{
							this.whatIsLoading = "Skyscraper";
						});

						this.ambience6Player.load("../src/assets/sounds/modules/metro/320/penthouse.m4a", 
							()=>{
							this.whatIsLoading = "Penthouse";
						});
					} else if (this.iOS === true){
						this.changeFX.load("../src/assets/sounds/blinks/change.m4a", 
						()=>{
						this.whatIsLoading = "Steel";
						});

						this.metroFX.load("../src/assets/sounds/modules/metro/192/metroFX.m4a", 
							()=>{
							this.whatIsLoading = "Concrete";
						});

						this.ambience1Player.load("../src/assets/sounds/modules/metro/192/street.m4a", 
							()=>{
							this.whatIsLoading = "Avenues";
						});

						this.ambience2Player.load("../src/assets/sounds/modules/metro/192/walla.m4a", 
							()=>{
							this.whatIsLoading = "Humans";
						});

						this.ambience3Player.load("../src/assets/sounds/modules/metro/192/subwaystation.m4a", 
							()=>{
							this.whatIsLoading = "Subway";
						});

						this.ambience4Player.load("../src/assets/sounds/modules/metro/192/subwaycar.m4a",
						 	()=>{
							this.whatIsLoading = "Subway Car";
						});

						this.ambience5Player.load("../src/assets/sounds/modules/metro/192/skyscraper.m4a", 
							()=>{
							this.whatIsLoading = "Skyscraper";
						});

						this.ambience6Player.load("../src/assets/sounds/modules/metro/192/penthouse.m4a", 
							()=>{
							this.whatIsLoading = "Penthouse";
						});
					}
				},					
	//GO HOME
					goHome(){
						this.changeFX.start();
						
								//IF USER ENGAGES VOICE CONTROL BUT GOES HOME VIA 
								//MOUSE BUTTON THIS TRIGGERS MODULE SPEECH DISPOSE
								if ((this.goingHomeNotViaVoiceCommand) && (!this.initSpeech)){
										this.stopModuleSpeech = true;
										this.recognitionNYC.stop();
										this.recognitionNYC.abort();
										this.recognitionNYC = undefined;
								};

								if (this.didWeAdventure === true){
									this.exploreSound1.disconnect();
									// this.exploreSound2.disconnect();
									// this.exploreSound3.disconnect();
								}

								
								setTimeout(()=>{
									Tone.Master.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.2);
									}, 400);
								
								setTimeout(()=>{
									this.ambience1Player.disconnect();
									this.ambience2Player.disconnect();
									this.ambience3Player.disconnect();
									this.ambience4Player.disconnect();
									this.ambience5Player.disconnect();
									this.ambience6Player.disconnect();
									this.metroFX.disconnect();
									this.changeFX.disconnect();
									this.masterVolumeSub.disconnect();
									if (this.userMobile === false){
										this.fxConvolver.disconnect(); 
										this.fxAutoFilter.disconnect(); 
										this.fxDelay.disconnect();
										this.fxChorus.disconnect(); 
										this.masterMeter.disconnect(); 
										}
									}, 1000);
								
								setTimeout(()=>{
									document.body.className = 'default';
									this.$router.push('/');
									Tone.Master.volume.value = 0;
									}, 1100);
					},
		}
	}
</script>
<style>
/** COLOR VARIABLES                         */
                  :root{      
                  --main-fxBadgesNYC-color: black !important;/*B26719*/
                  }
                  :root {
                  --main-startNYC-color: gold !important; /*3FE72A*/
                  }
                  :root {
                  --main-stopNYC-color: #2E5BCE !important;/*FF5C4A*/
                  }
                  :root {
                  --main-border-color: 4px solid transparent;
                  }
/** BACKGROUND CHANGES                      */
                  .backgroundColorNYC1{
                   background-color: #f1f3f3;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC2{
                   background-color: #e4e6e7;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC3{
                   background-color: #d6dadb;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC4{
                   background-color: #c9cecf;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC5{
                   background-color: #bbc1c3;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC6{
                   background-color: #aeb5b7;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC7{
                   background-color: #a0a9ab;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC8{
                   background-color: #939c9f;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC9{
                   background-color: #859093;
                   transition: background 0.1s linear;
                  }
                  .backgroundColorNYC10{
                   background-color: #788487;
                   transition: background 0.1s linear;
                  }
/** REACTIVE CHANGES                        */
                  .sunReactiveColorClassNYC1{
                   background-color: #788487;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC2{
                   background-color: #859093;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC3{
                   background-color: #939c9f;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC4{
                   background-color: #a0a9ab;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC5{
                   background-color: #aeb5b7;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC6{
                   background-color: #bbc1c3;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC7{
                   background-color: #c9cecf;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC8{
                   background-color: #d6dadb;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC9{
                   background-color: #e4e6e7;
                   transition: background 0.25s linear;
                  }
                  .sunReactiveColorClassNYC10{
                   background-color: white;
                   transition: background 0.25s linear;
                  }
/** BOOTSTRAP BUTTON COLORS 			    */
	.btn-mattChillOffNYC,
    .btn-mattChillOffNYC:focus, 
    .btn-mattChillOffNYC:active, 
    .btn-mattChillOffNYC.active, 
    .btn-mattChillOffNYC:active:focus,
    .open>.dropdown-toggle.btn-mattChillOffNYC {
    color: white;
    background-color:var(--main-stopNYC-color);
    border-width: 2px;
    border-color: transparent;
    }

    .btn-mattChillOffNYC:hover, 
    .btn-mattChillOffNYC:active:hover{
    color: black;
    background-color:var(--main-startNYC-color);;
    border-width: 2px;
    border-color: transparent;
    }

    .btn-mattChillOnNYC,
    .btn-mattChillOnNYC:focus, 
    .btn-mattChillOnNYC:active, 
    .btn-mattChillOnNYC.active, 
    .btn-mattChillOnNYC:active:focus,
    .open>.dropdown-toggle.btn-mattChillOnNYC {
    color: black;
    background-color: var(--main-startNYC-color);
    border-width: 2px;
    border-color: transparent;
    }

    .btn-mattChillOnNYC:hover, 
    .btn-mattChillOnNYC:active:hover{
    color: white;
    background-color:var(--main-stopNYC-color);;
    border-width: 2px;
    border-color: transparent;
    }

	.btn-helpBtn1NYC,
    .btn-helpBtn1NYC:focus, 
    .btn-helpBtn1NYC:active, 
    .btn-helpBtn1NYC:active, 
    .btn-helpBtn1NYC:active:focus,
    .open>.dropdown-toggle.btn-helpBtn1NYC {
    color: black;
    background-color: transparent;
    border-color: transparent; 
    border-width: 2px;
    } 

    .btn-helpBtn1NYC:hover,
	.btn-helpBtn1NYC:active:hover{
	color: gold;
	background-color: transparent;
	border-color: gold; 
	border-width: 2px;      
	}

    .btn-helpBtn2NYC,
    .btn-helpBtn2NYC:focus, 
    .btn-helpBtn2NYC:active, 
    .btn-helpBtn2NYC:active, 
    .btn-helpBtn2NYC:active:focus,
    .btn-helpBtn2NYC:hover,
	.btn-helpBtn2NYC:active:hover,
    .open>.dropdown-toggle.btn-helpBtn2NYC {
    background: var(--main-fxBadgesNYC-color);
	color: gold;
    border-color: transparent;
    -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.4);    
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4); 
    } 

	/*.btn-helpBtn2:hover,
	.btn-helpBtn2:active:hover{
	color: gold;
	background-color: transparent;
	border-color: gold; 
	border-width: 2px;      
	}*/

	.btn-playNYC,
    .btn-playNYC:hover, 
    .btn-playNYC:focus, 
    .btn-playNYC:active, 
    .btn-playNYC:active, 
    .btn-playNYC:active:focus,
    .btn-playNYC:active:hover,
    .open>.dropdown-toggle.btn-playNYC {
    color: black;
    background-color: var(--main-startNYC-color);
    border-color: var(--main-startNYC-color);; 
    border-width: 2px;
    -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.2);    
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4); 
    }

    .btn-stopNYC,
    .btn-stopNYC:hover, 
    .btn-stopNYC:focus, 
    .btn-stopNYC:active, 
    .btn-stopNYC:active, 
    .btn-stopNYC:active:focus,
    .btn-stopNYC:active:hover, 
    .open>.dropdown-toggle.btn-stopNYC {
    color: white;
    background-color: var(--main-stopNYC-color);
    border-color: var(--main-stopNYC-color); 
    border-width: 2px;
    -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.4);    
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4); 
    }

    .btn-micOpenBtnNYC,
    .btn-micOpenBtnNYC:focus, 
    .btn-micOpenBtnNYC:active, 
    .btn-micOpenBtnNYC:active, 
    .btn-micOpenBtnNYC:active:focus,
    .btn-micOpenBtnNYC:hover,
	.btn-micOpenBtnNYC:active:hover
    .open>.dropdown-toggle.btn-micOpenBtnNYC {
    color: white;
    background-color: var(--main-stopNYC-color);
    border-color: transparent; 
    border-width: 2px;
    } 

   /* .btn-micOpenBtnNYC:hover,
	.btn-micOpenBtnNYC:active:hover{
	color:  black;
	background-color:  var(--main-startNYC-color);
	border-color: gold; 
	border-width: 2px;      
	}*/

    .btn-micClosedBtnNYC,
    .btn-micClosedBtnNYC:focus, 
    .btn-micClosedBtnNYC:active, 
    .btn-micClosedBtnNYC:active, 
    .btn-micClosedBtnNYC:active:focus,
    .btn-micClosedBtnNYC:hover,
	.btn-micClosedBtnNYC:active:hover
    .Closed>.dropdown-toggle.btn-micClosedBtnNYC {
   	color:  black;
	background-color:  var(--main-startNYC-color);
    border-color: transparent; 
    border-width: 2px;
    } 

	/*.btn-micClosedBtnNYC:hover,
	.btn-micClosedBtnNYC:active:hover{
	color: white;
	background-color: var(--main-stopNYC-color);
	border-color: gold; 
	border-width: 2px;      
	}	*/
/** INSTRUMENT RANGER           			*/
                  input[class="instrumentRangerNYC"]{
                  background: var(--main-fxBadgesNYC-color);
                  }
                  input[class="instrumentRangerNYC"]::-moz-range-track{
                  background: var(--main-fxBadgesNYC-color);
                  }
                  input[class="instrumentRangerNYC"]::-webkit-slider-thumb{
                  background: var(--main-fxBadgesNYC-color);
                  }
                  input[class="instrumentRangerNYC"]::-moz-range-thumb{
                  background: var(--main-fxBadgesNYC-color);
                  }
                  input[class="instrumentRangerNYC"]::-ms-thumb{
                  background: black;
                  }  
                  input[class=instrumentRangerNYC]::-ms-fill-upper {
				  background:  #2E5BCE;
				  }
				  input[class=instrumentRangerNYC]::-ms-fill-lower {
				  background:  gold;
				  }
/** AMBIANCE RANGER STOPPED     			*/
                  input[class="ambianceRangerStopNYC"]{
                  background-color: var(--main-stopNYC-color);
                  }
                  input[class="ambianceRangerStopNYC"]::-webkit-slider-thumb {
                  background: var(--main-stopNYC-color);
                  }
                  input[class="ambianceRangerStopNYC"]::-moz-range-track{
                  background-color: var(--main-stopNYC-color);
                  }
                  input[class="ambianceRangerStopNYC"]::-moz-range-thumb{
                  background: var(--main-stopNYC-color);
                  }
                   input[class="ambianceRangerStopNYC"]::-ms-thumb{
                  	background: black;
                  }  
                  input[class=ambianceRangerStopNYC]::-ms-fill-upper {
					background:  #2E5BCE;
				  }
				  input[class=ambianceRangerStopNYC]::-ms-fill-lower {
					background:  gold;
				  }
/** AMBIANCE RANGER PLAYING     			*/
                  input[class="ambianceRangerPlayNYC"]{
                  background-color: var(--main-startNYC-color);
                  }
                  input[class="ambianceRangerPlayNYC"]::-webkit-slider-thumb {
                  background: var(--main-startNYC-color);
                  }  
                  input[class="ambianceRangerPlayNYC"]::-moz-range-track{
                  background-color: var(--main-startNYC-color);
                  }
                  input[class="ambianceRangerPlayNYC"]::-moz-range-thumb{
                  background: var(--main-startNYC-color);
                  }  
                   input[class="ambianceRangerPlayNYC"]::-ms-thumb{
                  	background: #838BC5;
                  }  
                  input[class=ambianceRangerPlayNYC]::-ms-fill-upper {
					background:  #BA9BC9;
				  }
				  input[class=ambianceRangerPlayNYC]::-ms-fill-lower {
					background:  #65C8D0;
				  }
/** SPEECH BUTTONS							*/
	.recordingClassDisengagedNYC{
	background: var(--main-fxBadgesNYC-color);
	color: var(--main-startNYC-color);
    border-color: transparent;
    -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.4);    
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4); 
	} 
	.recordingClassEngagedNYC{
    background: var(--main-startNYC-color);
    color: var(--main-fxBadgesNYC-color);
    border-color: transparent;
    -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.2);    
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4); 
	} 
	.btn-speechSubmitOff,
    .btn-speechSubmitOff:hover, 
    .btn-speechSubmitOff:focus, 
    .btn-speechSubmitOff:active, 
    .btn-speechSubmitOff:active, 
    .btn-speechSubmitOff:active:focus,
    .btn-speechSubmitOff:active:hover,
    .open>.dropdown-toggle.btn-speechSubmitOff {
    color: var(--main-startNYC-color);
    background-color: var(--main-fxBadgesNYC-color);
    border-color: var(--main-fxBadgesNYC-color); 
    border-width: 2px;
    -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.4);    
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4);
    }
    .btn-speechSubmitOn,
    .btn-speechSubmitOn:hover, 
    .btn-speechSubmitOn:focus, 
    .btn-speechSubmitOn:active, 
    .btn-speechSubmitOn:active, 
    .btn-speechSubmitOn:active:focus,
    .btn-speechSubmitOn:active:hover, 
    .open>.dropdown-toggle.btn-speechSubmitOn {
    color: white;
    background-color: var(--main-startNYC-color);
    border-color: var(--main-startNYC-color); 
    border-width: 2px;
    -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.0);
    -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.0);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.0);    
    text-shadow: 0px 6px 2px rgba(0, 0, 0, 0.4);
    }
#voiceCommandListID{
	color: var(--main-startNYC-color);
	background-color: var(--main-fxBadgesNYC-color);
}
.voiceBadgeNYC{
        background: var(--main-fxBadgesNYC-color);
        color: black;
        }
</style>





// WEBPACK FOOTER //
// nyc.vue?7b84f014